<template>
  <main id="create-quote-page" class="page-container">
    <!-- Container in alto a destra per il pulsante toggle -->
    <div class="toggle-list-btn-container">
      <button
        @click="toggleItemsList"
        class="toggle-list-btn"
        :class="{ shifted: showItemsList }"
      >
        <img
          v-if="!showItemsList"
          :src="require('@/assets/plus_Icon.png')"
          alt="toggle-list"
          class="icon"
        />
        <img
          v-else
          :src="require('@/assets/minus_Icon.png')"
          alt="toggle-list"
          class="icon"
        />
        {{ showItemsList ? "Nascondi" : "Mostra" }} lista articoli
      </button>
    </div>

    <!-- Modal per lista articoli -->
    <VueFinalModal
      v-model="showItemsList"
      :clickToClose="true"
      :escToClose="true"
      classes="items-list-modal"
      content-class="items-list-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="toggleItemsList">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Articoli aggiunti</h3>

        <div class="items-table-wrap">
          <table class="items-table" :style="{ '--item-col-w': itemColWidth }">
            <colgroup>
              <!-- 1) Articolo: dinamica in base ai caratteri -->
              <col :style="{ width: itemColWidth }" />
              <!-- 2) Le altre: lasciamo auto, garantiamo min-width via CSS -->
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>Articolo</th>
                <th>Categoria</th>
                <th>Quantità al Mq</th>
                <th>Quantità</th>
                <th>Venduti</th>
                <th>Prezzo unitario</th>
                <th>IVA</th>
                <th>Azione</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in formData.items" :key="index">
                <td>
                  <div class="item-title">
                    {{
                      displayForId(
                        item.itemId || item.outstockId,
                        categoryHintForRow(item)
                      ).title
                    }}
                  </div>
                  <div
                    v-if="
                      displayForId(
                        item.itemId || item.outstockId,
                        categoryHintForRow(item)
                      ).meta
                    "
                    class="item-meta"
                  >
                    {{
                      displayForId(
                        item.itemId || item.outstockId,
                        categoryHintForRow(item)
                      ).meta
                    }}
                  </div>
                </td>
                <!-- <td>
                  {{
                    getItemFromStore(item.itemId || item.outstockId).category
                  }}
                </td> -->
                <td>
                  {{
                    getItemFromStore(
                      item.itemId || item.outstockId,
                      categoryHintForRow(item)
                    ).category
                  }}
                </td>
                <td
                  :class="[
                    'qty-cell',
                    { 'qty-editable': isOutstockTiles(item) },
                  ]"
                  @click="
                    isOutstockTiles(item) &&
                      editingQty.idx !== index &&
                      startQtyEdit(index, item.pieces || 0)
                  "
                  :title="
                    isOutstockTiles(item) ? 'Clicca per modificare i mq' : ''
                  "
                >
                  <input
                    v-if="editingQty.idx === index && isOutstockTiles(item)"
                    :ref="`qtyInput_${index}`"
                    type="number"
                    class="qty-input"
                    v-model.number="editingQty.value"
                    min="0.01"
                    step="any"
                    @input="updateQtyLive(index, editingQty.value)"
                    @keydown.enter="closeQtyEdit"
                    @keydown.escape="cancelQtyEdit"
                    @blur="closeQtyEdit"
                  />
                  <span v-else>{{ mqCell(item) }}</span>
                </td>
                <td
                  :class="[
                    'qty-cell',
                    { 'qty-editable': qtyCell(item) !== '-' },
                  ]"
                  @click="
                    qtyCell(item) !== '-' &&
                      editingQty.idx !== index &&
                      startQtyEdit(index, qtyCell(item))
                  "
                  :title="
                    qtyCell(item) !== '-'
                      ? 'Clicca per modificare la quantità'
                      : ''
                  "
                >
                  <input
                    v-if="editingQty.idx === index && !isOutstockTiles(item)"
                    :ref="`qtyInput_${index}`"
                    type="number"
                    class="qty-input"
                    v-model.number="editingQty.value"
                    min="0.01"
                    step="any"
                    @input="updateQtyLive(index, editingQty.value)"
                    @keydown.enter="closeQtyEdit"
                    @keydown.escape="cancelQtyEdit"
                    @blur="closeQtyEdit"
                  />
                  <span v-else>{{ qtyCell(item) }}</span>
                </td>
                <td class="venduti-cell">
                  <span
                    v-if="vendutiInfo(item).needsProcurement"
                    class="venduti venduti--procure"
                    :title="procureTitle(item)"
                  >
                    {{ vendutiInfo(item).sold }}
                    <span class="badge-procure"
                      >da ordinare {{ vendutiInfo(item).procure }}</span
                    >
                  </span>
                  <span v-else class="venduti">{{
                    vendutiInfo(item).sold
                  }}</span>
                </td>
                <td>{{ formatPrice(item.price) }} {{ unitForRow(item) }}</td>
                <td class="iva-cell">
                  <!-- sc-48743: IVA modificabile dalla riga, come la quantità -->
                  <AppSelect
                    class="iva-select"
                    :modelValue="Number(item.iva ?? 22)"
                    :options="aliquoteIvaOptions"
                    title="Cambia l'IVA della riga (il prezzo si ricalcola)"
                    ariaLabel="IVA della riga"
                    @change="updateRowIva(index, $event)"
                  />
                </td>
                <td>
                  <button
                    class="icons-button"
                    id="remove-item-button"
                    @click="removeItem(index)"
                    title="Rimuovi articolo dalla lista"
                    aria-label="Rimuovi articolo dalla lista"
                  >
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="formData.items.length === 0">
                <td colspan="8" class="no-result">Nessun articolo presente</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </VueFinalModal>

    <!-- modale aggiunta nuovo articolo fuori magazzino -->
    <VueFinalModal
      v-model="showNewOutstockModal"
      :clickToClose="!creatingOutstock"
      :escToClose="!creatingOutstock"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="closeNewOutstockModal"
          :disabled="creatingOutstock"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Nuovo articolo fuori magazzino</h3>
        <div class="modal__subtitle" style="margin-bottom: 8px">
          Scegli la sottocategoria e compila i campi obbligatori.
        </div>

        <!-- SOTTOCATEGORIA -->
        <div class="field">
          <label>Sottocategoria</label>
          <AppSelect
            v-model="newOutstock.subCategory"
            :options="subCategoryOptions"
            placeholder="— scegli —"
          />
        </div>

        <!-- PIASTRELLE -->
        <template v-if="newOutstock.subCategory === 'piastrelle'">
          <div class="field">
            <label>Nome articolo *</label>
            <input
              type="text"
              v-model.trim="newOutstock.itemName"
              placeholder="es. Serie X Rovere"
            />
          </div>
          <div class="field">
            <label for="widthCm">Larghezza (cm)</label>
            <input
              id="widthCm"
              type="number"
              min="0"
              step="0.1"
              v-model.number="newOutstock.widthCm"
              placeholder="es. 50"
            />
          </div>
          <div class="field">
            <label for="heightCm">Altezza (cm)</label>
            <input
              id="heightCm"
              type="number"
              min="0"
              step="0.1"
              v-model.number="newOutstock.heightCm"
              placeholder="es. 50"
            />
          </div>

          <small v-if="tilesMeasurePreview" class="measure-preview">
            Anteprima misura: {{ tilesMeasurePreview }}
          </small>

          <div class="field">
            <label>Prezzo al Mq *</label>
            <input
              type="number"
              min="0"
              step="0.01"
              v-model.number="newOutstock.sqmPrice"
            />
          </div>
        </template>

        <!-- SANITARI / ALTRO -->
        <template
          v-else-if="
            newOutstock.subCategory === 'sanitari' ||
            newOutstock.subCategory === 'altro'
          "
        >
          <div class="field">
            <label>Brand</label>
            <input
              type="text"
              v-model.trim="newOutstock.brand"
              placeholder="es. Ideal Standard"
            />
          </div>
          <!-- SANITARI / ALTRO -->
          <div class="field">
            <label>Modello</label>
            <input
              type="text"
              v-model.trim="newOutstock.subBrand"
              placeholder="es. Gran Bastardone"
            />
          </div>

          <!-- <div class="field">
            <label>Pezzi *</label>
            <input
              type="number"
              min="0"
              step="1"
              v-model.number="newOutstock.quantity"
            />
          </div> -->
          <div class="field">
            <label>Prezzo (€) *</label>
            <input
              type="number"
              min="0"
              step="0.01"
              v-model.number="newOutstock.price"
            />
          </div>
        </template>

        <div class="modal-actions">
          <button
            class="secondary-btn"
            @click="closeNewOutstockModal"
            :disabled="creatingOutstock"
          >
            Annulla
          </button>
          <button
            class="primary-btn confirm-btn"
            @click="createNewOutstock"
            :disabled="creatingOutstock || !isNewOutstockValid"
          >
            <span v-if="creatingOutstock">Salvo…</span>
            <span v-else>Salva</span>
          </button>
        </div>
      </template>
    </VueFinalModal>

    <!-- Modale DUPLICATO preventivo -->
    <VueFinalModal
      v-model="showDuplicateModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content dup-modal__content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="closeDuplicateModal">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo già presente</h3>

        <p class="dup-modal__intro">
          Esiste già un preventivo per questo cliente allo stesso indirizzo in
          corso...
          <span
            v-if="lastDuplicateQuoteInfo?.address"
            class="dup-modal__address"
          >
            ({{ lastDuplicateQuoteInfo.address }}) </span
          >.
        </p>

        <!-- loading -->
        <div v-if="dupLoading" class="dup-modal__skeleton">
          Caricamento in corso…
        </div>
        <!-- error -->
        <div v-else-if="dupError" class="dup-modal__error">{{ dupError }}</div>

        <!-- dati -->
        <div v-else-if="dupQuote" class="dup-quote">
          <div class="dup-quote__grid">
            <div>
              <div class="dup-quote__label">ID</div>
              <div class="dup-quote__value">#{{ dupQuote.id }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Data</div>
              <div class="dup-quote__value">
                {{ formatToLocalDate(dupQuote.date) }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Cliente</div>
              <div class="dup-quote__value">
                {{ dupQuote.clientName || "—" }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Pagamento</div>
              <div class="dup-quote__value">{{ dupQuote.payment_method }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Indirizzo</div>
              <div class="dup-quote__value">
                <a
                  v-if="dupQuote.location?.link"
                  :href="dupQuote.location.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                >
                  {{ dupQuote.location?.address || "Vedi mappa" }}
                </a>
                <span v-else>{{ dupQuote.location?.address || "—" }}</span>
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Totale</div>
              <div class="dup-quote__value">
                {{ money(dupQuote.totalPrice) }}
              </div>
            </div>
          </div>

          <div class="dup-quote__items">
            <div class="dup-quote__items-head">
              <strong>Riepilogo articoli</strong>
              <span class="muted">({{ dupQuote.items?.length || 0 }})</span>
            </div>
            <ul class="dup-quote__items-list">
              <li
                v-for="(it, idx) in dupQuote.items || []"
                :key="idx"
                class="dup-item"
              >
                <div class="dup-item__name">
                  {{ it.itemName || it.brand || "Articolo" }}
                </div>
                <div class="dup-item__meta">
                  <span v-if="it.category" class="chip">{{ it.category }}</span>
                  <span v-if="it.boxQuantity"
                    >scatole: {{ it.boxQuantity }}</span
                  >
                  <span v-if="it.pieces">pezzi: {{ it.pieces }}</span>
                  <span v-if="it.iva !== undefined">IVA: {{ it.iva }}%</span>
                  <span v-if="it.price !== undefined"
                    >€ {{ number(it.price) }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="dup-modal__footer">
          <button
            v-if="dupQuote && !dupLoading && dupDocuments.length"
            class="btn-primary"
            @click="showDupDocs = true"
          >
            Apri file
          </button>

          <button class="btn-primary" @click="onChangeAddress">
            Usa indirizzo diverso
          </button>

          <button
            class="btn-ghost"
            :disabled="!lastDuplicateQuoteInfo?.quoteId"
            @click="onDuplicateWithEdit"
          >
            Duplica modificando indirizzo
          </button>
        </div>
      </template>
    </VueFinalModal>

    <!-- Modale documenti PDF del preventivo duplicato -->
    <VueFinalModal
      v-model="showDupDocs"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="documents-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="showDupDocs = false">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Preventivo #{{ dupQuote?.id }}</h3>

        <div class="documents-grid">
          <div v-for="doc in dupDocuments" :key="doc.id" class="document-card">
            <a href="#" class="card-link" @click.prevent="openDoc(doc)">
              <div class="card-icon-pdf">
                <i class="fa-solid fa-file-pdf"></i>
              </div>
              <div class="card-body">
                <div class="card-title">{{ formatDocName(doc.name) }}</div>
                <div class="card-subtitle">
                  Data di creazione: {{ formatToLocalDate(doc.createdAt) }}
                </div>
              </div>
            </a>
          </div>
          <div v-if="dupDocuments.length === 0" class="no-result">
            Nessun documento trovato
          </div>
        </div>
      </template>
    </VueFinalModal>

    <!-- Form principale -->
    <form
      class="create-quote-form"
      @submit.prevent="onUpdateQuoteAndGeneratePdf"
    >
      <!-- RIGA 1: Seleziona Cliente, data di inizio noleggio, data di fine noleggio e Operatore, Aggiungi Zona e categoria di articolo -->
      <div class="create-quote-row row-1">
        <!-- Seleziona Cliente -->
        <div class="field" id="client-select">
          <label>Cliente</label>

          <SearchableCombo
            v-model="clientIdModel"
            v-model:text="searchQueryClient"
            :items="filteredClients"
            :labelKey="getClientLabel"
            :valueKey="(c) => String(c?.id)"
            placeholder="Cerca cliente…"
            :loading="false"
            @search="
              (q) => {
                searchQueryClient = q || '';
              }
            "
            @select="
              (c) => {
                formData.clientId = c?.id ?? '';
              }
            "
          />
        </div>

        <!-- Data Preventivo -->
        <div class="field">
          <label for="date">Data</label>
          <input id="date" type="datetime-local" v-model="formData.date" />
        </div>
      </div>
      <div class="create-quote-row row-2">
        <!-- Località -->
        <div class="field">
          <label for="delivery-address">Indirizzo di consegna</label>
          <input
            ref="locationSearchBox"
            type="text"
            v-model="formData.location.address"
            placeholder="Inserisci l'indirizzo completo di consegna"
            class="address-input"
          />
        </div>

        <!-- modalità di pagamento -->
        <div class="field">
          <label for="payment-method">Modalità di pagamento</label>
          <AppSelect
            id="payment-method"
            v-model="formData.payment_method"
            :options="paymentMethodOptions"
            placeholder="Seleziona modalità di pagamento..."
          />
        </div>
      </div>
      <hr />

      <div class="create-quote-row row-3">
        <!-- scegli Articolo -->
        <div class="field" id="item-select">
          <label>Articolo</label>

          <SearchableCombo
            ref="itemCombo"
            v-model="newItem.itemId"
            v-model:text="searchQueryItem"
            :items="filteredItems"
            :labelKey="itemPickerLabel"
            :valueKey="(it) => it?.id"
            placeholder="Cerca articolo…"
            :disabled="isOutstockLocked"
            :loading="false"
            @search="(q) => debouncedFetchItems((q || '').trim())"
            @select="selectItem"
            @cleared="clearItemSelection"
          />
        </div>

        <!-- scegli eventuale Articolo fuori dal magazzino -->
        <div class="field" id="outstock-select">
          <label>Articolo fuori magazzino</label>

          <SearchableCombo
            ref="outCombo"
            v-model="newItem.outstockId"
            v-model:text="searchQueryOutstock"
            :items="filteredOutstock"
            :labelKey="nameForDisplay"
            :valueKey="(o) => o?.id"
            placeholder="Cerca articolo fuori magazzino…"
            :disabled="isStockLocked"
            :loading="false"
            @search="
              (q) => {
                const s = (q || '').trim();
                if (!s) {
                  filteredOutstock = defaultOutstocks();
                  return;
                }
                debouncedFetchOutstocks(s);
              }
            "
            @select="selectOutstock"
            @cleared="clearOutstockSelection"
          >
            <!-- bottone + a destra, identico al tuo -->
            <template #action>
              <i class="fa-solid fa-plus" @click.stop="openNewOutstockModal" />
            </template>
          </SearchableCombo>
        </div>

        <!-- Scegli quantità -->
        <div class="field">
          <label for="quantity">{{ quantityLabel }}</label>
          <input
            id="quantity"
            step="any"
            type="number"
            v-model="quantityInput"
            placeholder="Inserisci"
          />
        </div>

        <!-- quantità al Mq => readonly -->
        <div class="field" v-if="showMqField">
          <label for="mq-per-box">Quantità al Mq</label>
          <input
            :value="mqPerQuantity"
            type="text"
            placeholder="Seleziona la quantità di scatole per visualizzare i mq"
            readonly
            class="readonly-field"
          />
        </div>
      </div>

      <div class="create-quote-row row-4">
        <!-- Scegli Prezzo -->
        <div class="field">
          <label for="price">Prezzo</label>
          <input
            id="price"
            type="number"
            v-model="newItem.price"
            placeholder="Seleziona l'articolo per visualizzare il prezzo corrispondente"
            step="0.01"
            readonly
            class="readonly-field"
          />
        </div>
        <!-- Scegli sconto su iva (opzionale) -->
        <div class="field">
          <label for="vat-rate">IVA</label>
          <AppSelect
            id="vat-rate"
            v-model="newItem.iva"
            :options="aliquoteIvaOptions"
          />
        </div>
      </div>

      <!-- RIGA 5: bottone "+ aggiungi articolo" -->
      <div class="create-quote-row row-5">
        <!-- Bottone per aggiungere un ulteriore alla lista -->
        <div class="field">
          <button type="button" class="add-item-btn" @click="addOrUpdateItem">
            <!-- icona -->
            <img
              :src="require('@/assets/plus_Icon.png')"
              alt="aggiungi"
              class="icon"
            />
            <span>aggiungi articolo</span>
          </button>
        </div>
      </div>
    </form>

    <hr />

    <!-- RIGA 6: note + cambio lingua -->
    <div class="create-quote-row row-5">
      <!-- Richieste tecniche -->
      <div class="field">
        <label for="technical-requests">Note</label>
        <textarea
          id="technical-requests"
          v-model.trim="formData.technical_queries"
          placeholder="Inserisci note"
        ></textarea>
      </div>
      <!-- Esempio di dropdown per il cambio lingua -->
      <!-- <div class="field">
        <label for="lang-select">Lingua PDF:</label>
        <select v-model="$i18n.locale" id="lang-select" class="pdf-lang-select">
          <option value="it">Italiano</option>
          <option value="en">English</option>
        </select>
      </div> -->
    </div>

    <!-- Bottone Salva allineato a destra -->
    <div class="save-button-container">
      <!-- sc-48721: chi arriva dall'indirizzo diretto vede perché non può salvare -->
      <p v-if="modificaChiusa" class="modifica-chiusa">
        {{ msgPreventivoChiuso }}
      </p>
      <button
        id="update-quote-only"
        class="btn-secondary"
        @click="onUpdateQuoteAndGeneratePdf({ sendEmail: false })"
        :disabled="!canSave"
        title="Aggiorna preventivo ed esporta PDF"
      >
        Aggiorna ed esporta PDF
      </button>

      <button
        id="send-email-btn"
        class="btn-primary"
        @click="onSendEmailOnly"
        :disabled="!hasSavedInSession || isDraftDirty || !lastUploadedDocName"
        :title="
          !hasSavedInSession
            ? 'Aggiorna il preventivo prima di inviare'
            : isDraftDirty
            ? 'Salva le modifiche prima di inviare'
            : !lastUploadedDocName
            ? 'Salva il preventivo prima di inviare'
            : 'Invia via email'
        "
      >
        <i class="fa-solid fa-envelope" style="margin-right: 8px"></i>
        Invia via email
      </button>
    </div>
  </main>
</template>

<script>
import logoPath from "@/assets/emmamaison.png";
// import crypto from "crypto";
import axiosInstance from "@/axiosInstance";
import { openDocument } from "@/utilities/openDocument";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import debounce from "lodash/debounce";
// import { nextTick } from "process";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate, toDateTimeLocal } from "../utilities/formatting";
import {
  itemFullDescription,
  itemPickerLabel,
  itemTitle,
  outstockName,
} from "../utilities/itemDescription";
import { pdfSafe, pdfSafeRows } from "../utilities/pdfText";
import {
  calcolaImporti,
  disegnaRiquadroRiepilogo,
  righeRiepilogo,
  totaliImponibile,
} from "../utilities/pdfRiepilogo";
import { splitQty } from "../utilities/procurement";
import { ALIQUOTE_IVA, prezzoConIva } from "../utilities/iva";
import {
  MSG_PREVENTIVO_CHIUSO,
  preventivoNonModificabile,
} from "../utilities/pagamenti";
import SearchableCombo from "./SearchableCombo.vue";

// Chiavi cache namespaced: evitiamo collisioni tra items e outstocks con stessi id
const asKey = (id) => String(id ?? ""); // normalizza sempre a stringa
const KEY = {
  STOCK: (id) => `STOCK:${asKey(id)}`,
  OUT: (id) => `OUT:${asKey(id)}`,
};

// 👇 accetta sia stringa JSON che oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
};

export default {
  name: "EditQuotePage",
  components: { SearchableCombo },
  props: ["quoteId"],
  beforeRouteLeave(to, from, next) {
    if (this.isAutoSavePending) {
      this.$toast.info("Sincronizzazione bozza in corso...");

      // Forza l'esecuzione immediata del debounce
      if (typeof this.debouncedAutoSave?.flush === "function") {
        this.debouncedAutoSave.flush();
      }

      // Attendiamo che il salvataggio finisca prima di procedere
      const checkPending = setInterval(() => {
        if (!this.isAutoSavePending) {
          clearInterval(checkPending);
          next();
        }
      }, 100); // Controllo più frequente per velocità

      // Timeout di sicurezza
      setTimeout(() => {
        clearInterval(checkPending);
        if (this.isAutoSavePending) next();
      }, 3000);
    } else {
      next();
    }
  },

  async created() {
    this.$store
      .dispatch("fetchClients", { limit: 10000 })
      .catch((err) =>
        console.error("Impossibile caricare i clienti:", err.message)
      );
    this.$store
      .dispatch("fetchItems", { limit: 10000 })
      .catch((err) =>
        console.error("Impossibile caricare gli articoli:", err.message)
      );
    this.$store
      .dispatch("fetchOutstocks")
      .catch((err) =>
        console.error("Impossibile caricare outstock:", err.message)
      );

    // Non mutare la prop quoteId. Usiamo il valore che già arriva dalle props.
    this.draftId = this.$route.query.draftId
      ? Number(this.$route.query.draftId)
      : null;
    this.debouncedAutoSave = debounce(this.autoSaveDraft, 2500);
    this.debouncedFetchItems = debounce(this.fetchItems, 300);
    this.debouncedFetchOutstocks = debounce(this.fetchOutstocks, 300);

    // Carichiamo prima il preventivo originale
    await this.fetchQuoteData();

    // Poi applichiamo sopra la bozza, se presente, così che la bozza vinca sempre
    if (this.draftId) {
      await this.loadDraft(this.draftId);
    }
    this.isDraftDirty = false;
  },

  computed: {
    aliquoteIvaOptions() {
      return this.aliquoteIva.map((r) => ({ value: r, label: `${r}%` }));
    },
    canSave() {
      // vuoi anche impedire il salvataggio senza articoli
      const hasItems = (this.formData.items || []).length > 0;
      const dirty = this.computeSignature() !== this.originalSig;
      return (
        hasItems &&
        dirty &&
        !this.dupLoading &&
        !this.creatingOutstock &&
        !this.modificaChiusa
      );
    },
    isAddressValid() {
      return !!(this.formData.location?.address || "").trim();
    },

    outstocks() {
      return this.$store.getters["outstocks/list"] ?? [];
    },
    // selectedItem() {
    //   /* Se è stato scelto un articolo di magazzino */
    //   if (this.newItem.itemId) {
    //     return this.getItemFromStore(this.newItem.itemId); // ← già fa cache
    //   }
    //   /* Se è stato scelto un articolo FUORI magazzino */
    //   if (this.newItem.outstockId) {
    //     return (
    //       this.outstocks.find((o) => o.id === this.newItem.outstockId) || {}
    //     );
    //   }
    //   /* Nessuna selezione */
    //   return {};
    // },

    selectedItem() {
      if (this.newItem.itemId) {
        return this.getItemFromStore(this.newItem.itemId, "STOCK");
      }
      if (this.newItem.outstockId) {
        return this.getItemFromStore(
          this.newItem.outstockId,
          "Fuori Magazzino"
        );
      }
      return {};
    },

    quantityLabel() {
      if (this.selectedItem.category === "piastrelle")
        return "Quantità scatole";
      if (
        this.selectedItem.category === "Fuori Magazzino" &&
        this.selectedItem.subCategory === "piastrelle"
      )
        return "Quantità (mq)";
      if (this.selectedItem.category === "Fuori Magazzino") return "Quantità";
      return "Quantità pezzi";
    },

    // quantityInput: {
    //   get() {
    //     return this.selectedItem.category === "piastrelle"
    //       ? this.newItem.boxQuantity // lavoro in scatole
    //       : this.newItem.pieces; // lavoro in pezzi
    //   },
    //   set(v) {
    //     const n = +v || 0;
    //     if (this.selectedItem.category === "piastrelle") {
    //       // console.log("selectedItem in quantityinput", this.selectedItem);
    //       this.newItem.boxQuantity = n; // scatole
    //       const ppb = this.selectedItem.piecesPerBox || 1;
    //       this.newItem.pieces = n * ppb; // pezzi calcolati
    //       // this.newItem.unitPrice;
    //     } else {
    //       this.newItem.pieces = n; // sanitari
    //     }

    //     // ricalcolo per FUORI MAGAZZINO: totale = unit × qty
    //     if (this.selectedItem.category === "Fuori Magazzino") {
    //       const isTiles = this.selectedItem.subCategory === "piastrelle";
    //       const base = isTiles
    //         ? Number(this.selectedItem.sqmPrice) || 0
    //         : Number(this.selectedItem.price) || 0;

    //       const unit = Number(this.adjustedPrice(base, this.newItem.iva));
    //       this.newItem.unitPrice = unit;

    //       const qty = this.newItem.pieces || 0; // anche per mq
    //       this.newItem.price = (unit * qty).toFixed(2); // mostra il totale nel campo
    //     }
    //   },
    // },

    quantityInput: {
      get() {
        return this.selectedItem.category === "piastrelle"
          ? this.newItem.boxQuantity
          : this.newItem.pieces;
      },
      set(v) {
        const n = +v || 0;

        if (this.selectedItem.category === "piastrelle") {
          this.newItem.boxQuantity = n;
          const ppb = this.selectedItem.piecesPerBox || 1;
          this.newItem.pieces = n * ppb;
        } else {
          this.newItem.pieces = n;
        }

        if (this.selectedItem.category === "Fuori Magazzino") {
          const isTiles = this.selectedItem.subCategory === "piastrelle";
          const base = isTiles
            ? Number(this.selectedItem.sqmPrice) || 0
            : Number(this.selectedItem.price ?? this.newItem.unitPrice) || 0;

          const unit = Number(this.adjustedPrice(base, this.newItem.iva));
          this.newItem.unitPrice = unit;
          // this.newItem.pieces = n;

          const qty = this.newItem.pieces || 0;
          this.newItem.price = (unit * qty).toFixed(2);
        }
      },
    },

    /* Ponte per v-model mqPerQuantity */
    mqPerQuantity() {
      const s = this.selectedItem || {};

      // Magazzino: piastrelle → scatole * mq per scatola
      if (s.category === "piastrelle") {
        const sqmPerBox = Number(s.sqmPerBox) || 0;
        const boxes = Number(this.newItem.boxQuantity) || 0;
        const total = boxes * sqmPerBox;
        return total ? total.toFixed(2) : "";
      }

      // Fuori magazzino: piastrelle → la quantità inserita è già in mq
      // if (s.category === "Fuori Magazzino" && s.subCategory === "piastrelle") {
      //   const sqm = Number(this.newItem.pieces) || 0; // usi 'pieces' come mq
      //   return sqm ? sqm.toFixed(2) : "";
      // }

      // Altri casi (sanitari/altro)
      return "";
    },

    showMqField() {
      const s = this.selectedItem || {};
      if (!s || !s.category) return false;
      if (s.category === "piastrelle") return true; // stock: piastrelle
      // if (s.category === "Fuori Magazzino")
      //   // outstock: piastrelle
      //   return s.subCategory === "piastrelle";
      return false; // sanitario, altro, ecc.
    },

    clients() {
      return this.$store.getters["clients/list"] ?? [];
    },
    items() {
      return this.$store.getters["items/list"] ?? [];
    },

    filteredClients() {
      const q = (this.searchQueryClient || "").toLowerCase().trim();
      const list = this.clients || [];
      let res = q
        ? list
            .filter((c) => (c.clientName || "").toLowerCase().includes(q))
            .slice(0, 4)
        : list.slice(0, 4);

      const selId = this.formData.clientId;
      const selected = list.find((c) => c.id === selId);
      if (selected && !res.some((c) => c.id === selId)) {
        res = [selected, ...res].slice(0, 4);
      }
      return res;
    },

    // Tutti i nomi da mostrare nella colonna "Articolo"
    itemNames() {
      return (this.formData.items || []).map(
        (row) =>
          this.getItemName(row.itemId || row.outstockId, row.category) || ""
      );
    },

    // Lunghezza massima in caratteri tra i nomi
    maxItemLen() {
      return this.itemNames.reduce((m, s) => Math.max(m, s.length), 0);
    },

    // Larghezza dinamica della colonna "Articolo" in ch, con limiti per non rompere il layout
    // - min 180px (leggibile anche con nomi brevi)
    // - valore centrale in ch (caratteri) = maxArtLen + 6 (un po' di respiro)
    // - max 52vw (mai oltre metà viewport nel modale)
    itemColWidth() {
      const ch = Math.max(10, Math.min(this.maxItemLen + 6, 72)); // clamp “logico”
      return `clamp(180px, ${ch}ch, 52vw)`;
    },

    isStockLocked() {
      return !!this.newItem.itemId;
    }, // blocca outstock se c'è un articolo
    isOutstockLocked() {
      return !!this.newItem.outstockId;
    }, // blocca articolo se c'è un outstock

    isNewOutstockValid() {
      const sub = (this.newOutstock.subCategory || "").toLowerCase();
      if (!sub) return false;

      const strOk = (v) => !!(v && v.toString().trim().length > 0);
      const numPos = (v) => Number.isFinite(+v) && +v > 0;

      if (sub === "piastrelle") {
        const nameOk = strOk(this.newOutstock.itemName);
        const sqmOk = numPos(this.newOutstock.sqmPrice);

        const w = this.newOutstock.widthCm;
        const h = this.newOutstock.heightCm;
        const wSet = w !== null && w !== undefined && w !== "";
        const hSet = h !== null && h !== undefined && h !== "";

        // Se una misura è presente, richiedi entrambe positive
        const dimsOk = (!wSet && !hSet) || (numPos(w) && numPos(h));

        return nameOk && sqmOk && dimsOk;
      }

      // sanitari / altro
      const brandOk = strOk(this.newOutstock.brand);
      const priceOk = numPos(this.newOutstock.price);
      return brandOk && priceOk;
    },

    tilesMeasurePreview() {
      if (this.newOutstock.subCategory !== "piastrelle") return "";
      const w = Number(this.newOutstock.widthCm);
      const h = Number(this.newOutstock.heightCm);
      if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
        return `${h}x${w} cm`;
      }
      return "";
    },

    clientIdModel: {
      get() {
        const v = this.formData.clientId;
        return v === null || v === undefined ? "" : String(v);
      },
      set(v) {
        // se preferisci tenerlo number nello stato:
        this.formData.clientId = v ? Number(v) : "";
      },
    },
  },

  data() {
    return {
      originalSig: "",
      modificaChiusa: false, // sc-48721
      msgPreventivoChiuso: MSG_PREVENTIVO_CHIUSO,

      // Venduti (sc-47204): warehouse già impegnato dal preventivo per ogni itemId,
      // così l'anteprima split in modifica replica il backend
      // (disponibilità = stockCorrente + warehouseVecchio della riga).
      originalWarehouseByItemId: {},

      showDuplicateModal: false,
      lastDuplicateQuoteInfo: { quoteId: null, address: null },
      showDupDocs: false,
      dupDocuments: [],
      dupLoading: false,
      dupError: "",
      dupQuote: null,

      showDropdown: false,
      searchQueryItem: "",
      searchQueryOutstock: "",
      searchQueryClient: "",
      filteredItems: [],
      filteredOutstock: [],
      // selectedItemById: {},
      selectedByKey: {}, // dizionario di cache locale (sia stock che outstock)
      // selectedOutstockById: {},
      showItemsList: false,
      activeSearch: null, // 'client' o 'item' o null
      selectedIndex: -1, // Indice dell'opzione attualmente evidenziata
      response: "",
      image: logoPath,

      /* 🔵 stato modale nuovo outstock */
      showNewOutstockModal: false,
      creatingOutstock: false,
      newOutstock: {
        subCategory: "", // ← nessuna scelta di default
        // piastrelle
        itemName: "",
        // sqmQuantity: null,
        sqmPrice: null,
        // sanitari/altro
        brand: "",
        subBrand: "",
        // quantity: null,
        price: null,
        widthCm: null,
        heightCm: null,
      },

      formData: {
        location: {
          name: "",
          address: "",
        },
        clientId: "",
        items: [],
        date: "",
        outstocks: [],
        outstockId: null,
        payment_method: "",
        technical_queries: "",
      },
      newItem: {
        itemId: null,
        outstockId: null, // ← per articoli fuori magazzino
        boxQuantity: 0, // ← scatole, solo per piastrelle
        pieces: 0, // ← pezzi fisici (sanitari) o calcolati
        price: "",
        iva: 22,
        category: "",
        quantity: 0,
        unitPrice: 0, // prezzo unitario per articoli fuori magazzino
        // sqmPerBox: "", // solo per piastrelle
      },
      errorMessage: "",
      successMessage: "",
      selectedPlaceId: "",
      // Draft state
      draftId: null,
      isSavingDraft: false,
      isAutoSavePending: false,
      needsReSave: false,
      isDraftDirty: false, // Traccia se ci sono modifiche non salvate
      hasSavedInSession: false, // Abilitato dopo il primo salvataggio nella sessione corrente
      editingQty: { idx: null, value: null, originalValue: null },
      aliquoteIva: ALIQUOTE_IVA, // sc-48743: form e righe usano le stesse
      subCategoryOptions: [
        { value: "piastrelle", label: "Piastrelle" },
        { value: "sanitari", label: "Sanitari" },
        { value: "altro", label: "Altro" },
      ],
      paymentMethodOptions: [
        { value: "Contanti", label: "Contanti" },
        { value: "Carta di credito", label: "Carta di credito" },
        { value: "Bonifico", label: "Bonifico" },
      ],
      isPdfGenerated: false, // Flag per tracciare se il PDF è stato generato post-salvataggio
      lastUploadedDocName: null, // Nome del PDF caricato (usato per l'invio email separato)
    };
  },
  methods: {
    async openDoc(doc) {
      try {
        await openDocument(doc);
      } catch (err) {
        console.error("Errore nell'apertura del documento:", err);
        this.$toast.error("Impossibile aprire il documento");
      }
    },
    async onSendEmailOnly() {
      if (this.isDraftDirty || !this.quoteId || !this.lastUploadedDocName) {
        this.$toast.error("Salva le modifiche prima di inviare l'email");
        return;
      }
      const quoteClient =
        this.clients.find((c) => c.id === this.formData.clientId) || null;
      const contact = quoteClient?.pec || quoteClient?.email || "";
      try {
        this.$toast.info("Invio email al cliente...");
        await this.$store.dispatch("sendQuoteEmail", {
          quoteId: this.quoteId,
          objectName: this.lastUploadedDocName,
          contact,
        });
        if (contact) {
          this.$toast.success("Email inviata con successo!");
        } else {
          this.$toast.warning(
            "PDF caricato, ma il cliente non ha email o PEC: email non inviata."
          );
        }
        setTimeout(() => this.$router.push({ name: "quotes" }), 2000);
      } catch (err) {
        console.error("Errore invio email:", err);
        this.$toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            "Errore durante l'invio dell'email."
        );
      }
    },
    // sanitize stringhe nel payload prima dell'update
    sanitizeStr(s, { maxLen = 5000 } = {}) {
      if (s == null) return "";
      let out = String(s).trim();

      // rimuovi caratteri di controllo (tranne tab/newline)
      // out = out.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, " ");

      // strip tag HTML basilare
      out = out.replace(/<[^>]*>/g, " ");

      // normalizza spazi multipli
      out = out.replace(/\s{2,}/g, " ").replace(/\n{3,}/g, "\n\n");

      // limita lunghezza
      if (out.length > maxLen) out = out.slice(0, maxLen);

      return out;
    },
    cleanNumber(n, { min = null } = {}) {
      const v = Number(n);
      if (!Number.isFinite(v)) return 0;
      if (min != null && v < min) return min;
      return v;
    },

    // Riconosce se è piastrella (anche per Fuori Magazzino)
    isTilesObj(src) {
      return (
        src?.category === "piastrelle" ||
        (src?.category === "Fuori Magazzino" &&
          src?.subCategory === "piastrelle")
      );
    },

    // Nome da mostrare ovunque (tabella modale + PDF)
    nameForDisplay(src) {
      return this.itemDisplayFromObj(src || {}).title || "Sconosciuto";
    },

    // Esposto al template per il menu di selezione articolo (sc-48197)
    itemPickerLabel,

    // Capitallizza la prima lettera
    Cap(s) {
      return (s || "")
        .toString()
        .trim()
        .replace(/^\w/, (c) => c.toUpperCase());
    },

    /**
     * Ritorna { title, meta } a partire dall'oggetto articolo/outstock già risolto.
     * Il titolo è delegato a itemTitle() (utilities/itemDescription.js), unico
     * per UI e PDF; qui resta la sola logica del "meta":
     * - Piastrelle (magazzino): meta = measureDesc (oppure WxH cm)
     * - Fuori Magazzino/Piastrelle: meta fisso "Piastrelle"
     * - Sanitari/Altro: meta = tipo/posizione (fallback subCategory)
     */
    itemDisplayFromObj(it = {}) {
      // Il titolo e' composto da itemTitle(): regola unica per UI e PDF (sc-48197)
      const title = itemTitle(it);

      // --- PIASTRELLE (STOCK) ---
      if (it.category === "piastrelle") {
        const meta =
          it.measureDesc ||
          (it.widthCm && it.heightCm
            ? `${it.widthCm}×${it.heightCm} cm`
            : null) ||
          "Piastrelle"; // <- fallback visibile
        return { title, meta };
      }

      // --- FUORI MAGAZZINO: PIASTRELLE ---
      if (
        it.category === "Fuori Magazzino" &&
        it.subCategory === "piastrelle"
      ) {
        return {
          title,
          meta: "Piastrelle",
        };
      }

      // --- SANITARI / ALTRO (STOCK) ---
      // accetta anche eventuali chiavi legacy/type/position e usa category come fallback
      const T = this.Cap(it.fixtureType || it.type || it.category || "");
      const P =
        (it.fixturePosition || it.position) === "terra"
          ? "a terra"
          : this.Cap(it.fixturePosition || it.position || "");

      const metaParts = [T, P].filter(Boolean);
      const meta =
        (metaParts.length ? metaParts.join(" ") : null) ||
        this.Cap(it.subCategory || it.category || ""); // <- altro fallback

      return { title, meta };
    },
    /**
     * Ritorna { title, meta } cercando nel negozio partendo da id + hint categoria
     */
    displayForId(id, categoryHint) {
      if (!id) return { title: "Sconosciuto", meta: "" };
      const src = this.getItemFromStore(id, categoryHint) || {};
      if (src && src.id != null) return this.itemDisplayFromObj(src);

      // fallback: prova a leggere la riga già mappata in formData.items
      const row = (this.formData.items || []).find((r) =>
        categoryHint === "Fuori Magazzino"
          ? r.outstockId === id
          : r.itemId === id
      );
      if (row) {
        // ricostruisci un minimo di oggetto per la formattazione
        return this.itemDisplayFromObj({
          id,
          category: row.category,
          itemName: row.itemName,
          brand: row.brand,
          subBrand: row.subBrand,
          subCategory: row.subCategory,
        });
      }
      return { title: "Sconosciuto", meta: "" };
    },

    // normalizza solo i campi "di valore" (UI effimera esclusa)
    normalizeForCompare() {
      const f = this.formData || {};
      const L = f.location || {};
      const loc = (L.address || "").trim() || null;

      const items = (f.items || [])
        .map((r) => {
          const isOut = r.category === "Fuori Magazzino";
          const id = isOut ? r.outstockId : r.itemId;
          const qty = isOut
            ? Number(r.pieces || r.quantity || 0) // outstock (mq o pezzi)
            : Number(r.boxQuantity || r.pieces || 0); // stock (scatole o pezzi)
          const price = Number(r.unitPrice ?? r.price ?? 0); // prezzo unitario effettivo
          const iva = Number(r.iva ?? 22);
          return { isOut, cat: r.category || "", id, qty, price, iva };
        })
        // ordinamento stabile per non far cambiare la firma se cambia l'ordine visuale
        .sort(
          (a, b) =>
            a.isOut - b.isOut ||
            a.cat.localeCompare(b.cat) ||
            String(a.id || "").localeCompare(String(b.id || ""))
        );

      return {
        clientId:
          f.clientId === "" || f.clientId === null || f.clientId === undefined
            ? null
            : Number(f.clientId),
        date: f.date || "",
        payment_method: f.payment_method || "",
        technical_queries: f.technical_queries || "",
        location: loc,
        items,
      };
    },

    normalizeLocFromApi(raw) {
      if (!raw) return { name: "", address: "" };
      const obj =
        typeof raw === "string"
          ? (() => {
              try {
                return JSON.parse(raw);
              } catch {
                return {};
              }
            })()
          : raw;
      return {
        name: obj.name || "",
        address: obj.address || obj.formatted_address || "",
      };
    },

    computeSignature() {
      // stringify stabile: gli oggetti sono già normalizzati e ordinati
      return JSON.stringify(this.normalizeForCompare());
    },
    captureSnapshot() {
      this.originalSig = this.computeSignature();
    },

    async loadDuplicateQuote() {
      const id = this.lastDuplicateQuoteInfo?.quoteId;
      if (!id) return;

      this.dupLoading = true;
      this.dupError = "";
      this.dupQuote = null;

      try {
        const { data } = await axiosInstance.get(`/quote/${id}`, {
          withCredentials: true,
        });

        // location normalizzata
        let parsedLocation = null;
        try {
          parsedLocation =
            typeof data?.quote?.location === "string"
              ? JSON.parse(data.quote.location)
              : data?.quote?.location || null;
        } catch {
          parsedLocation = null;
        }

        // items normalizzati per il modale
        const items = (data?.quote?.quote_items || []).map((qi) => {
          const fromStock = !!qi.item;
          const cat = fromStock ? qi.item.category : qi.outstock.category;
          return {
            category: cat,
            itemName: fromStock
              ? qi.item.itemName || qi.item.subBrand
              : outstockName(qi.outstock),
            brand: fromStock ? qi.item.subBrand : qi.outstock.brand,
            boxQuantity: fromStock && cat === "piastrelle" ? qi.quantity : 0,
            pieces: fromStock && cat === "piastrelle" ? 0 : qi.quantity,
            iva: qi.iva ?? 22,
            price: Number(qi.price ?? 0),
          };
        });

        this.dupQuote = {
          ...data.quote,
          location: parsedLocation,
          totalPrice: data?.quote?.totalPrice ?? null,
          items,
        };
        this.dupDocuments = data?.quote?.documents || [];
      } catch (e) {
        this.dupError =
          e?.response?.data?.message ||
          "Impossibile caricare il preventivo esistente.";
      } finally {
        this.dupLoading = false;
      }
    },

    openDuplicateModal(quoteId, address) {
      this.lastDuplicateQuoteInfo = {
        quoteId: quoteId ?? null,
        address: address ?? null,
      };
      this.dupError = "";
      this.dupQuote = null;
      this.showDuplicateModal = true;
      if (this.lastDuplicateQuoteInfo.quoteId) this.loadDuplicateQuote();
    },
    closeDuplicateModal() {
      this.showDuplicateModal = false;
    },

    number(v) {
      return (typeof v === "number" ? v : Number(v || 0)).toFixed(2);
    },
    money(v) {
      return `€ ${this.number(v)}`;
    },
    formatDocName(name) {
      return (
        (name ?? "")
          .toString()
          // prima togli eventuale ".dev" immediatamente prima di ".pdf"
          .replace(/\.dev(?=\.pdf$)/i, "")
          // poi rimuovi "_N_<numero>.pdf" in fondo
          .replace(/_N_\d+\.pdf$/i, "")
      );
    },
    formatToLocalDate,

    onChangeAddress() {
      this.showDuplicateModal = false;
      this.$nextTick(() => this.$refs.locationSearchBox?.focus());
    },

    // In Edit carico il preventivo in conflitto e NE COPIO i contenuti nella form attuale,
    // svuotando l'indirizzo: salverai poi con il tuo update
    async onDuplicateWithEdit() {
      const sourceId = this.lastDuplicateQuoteInfo?.quoteId;
      this.showDuplicateModal = false;
      if (!sourceId) return;

      try {
        if (!this.dupQuote || this.dupQuote.id !== sourceId) {
          this.dupLoading = true;
          const { data } = await axiosInstance.get(`/quote/${sourceId}`, {
            withCredentials: true,
          });
          let loc = data?.quote?.location;
          try {
            loc = typeof loc === "string" ? JSON.parse(loc) : loc;
          } catch (error) {
            this.$toast.error(
              "Impossibile caricare il dettaglio di questo preventivo."
            );
          }
          this.dupQuote = { ...data.quote, location: loc };
        }
        const q = this.dupQuote;

        // mappa quote_items -> formData.items (schema Edit)
        const mappedItems = (q.quote_items || []).map((qi) => {
          if (qi.item) {
            const it = qi.item;
            const isTiles = it.category === "piastrelle";
            return {
              itemId: it.id,
              outstockId: null,
              itemName: it.itemName || it.subBrand,
              category: it.category,
              boxQuantity: isTiles ? qi.quantity : 0,
              pieces: isTiles ? 0 : qi.quantity,
              price: Number(qi.price),
              iva: qi.iva ?? 22,
            };
          }
          const os = qi.outstock;
          return {
            itemId: null,
            outstockId: os.id,
            itemName: os.itemName || os.subBrand,
            category: "Fuori Magazzino",
            boxQuantity: 0,
            pieces: qi.quantity,
            price: Number(qi.price),
            iva: qi.iva ?? 22,
          };
        });

        // cache per etichette
        (q.quote_items || []).forEach((qi) => {
          // if (qi.item) this.selectedItemById[qi.item.id] = qi.item;
          // if (qi.outstock) this.selectedItemById[qi.outstock.id] = qi.outstock;
          if (qi.item) this.selectedByKey[KEY.STOCK(qi.item.id)] = qi.item;
          if (qi.outstock)
            this.selectedByKey[KEY.OUT(qi.outstock.id)] = qi.outstock;
        });

        // compila la form con i dati del preventivo duplicato, ma svuota l'indirizzo
        this.formData = {
          ...this.formData,
          clientId: q.clientId,
          payment_method: q.payment_method || "",
          technical_queries: q.technical_queries || "",
          items: mappedItems,
          outstockId: "",
          location: {
            name: "",
            address: "",
          },
        };
        this.newItem = this.resetNewItem();

        this.$nextTick(() => {
          this.$refs.locationSearchBox?.focus();
        });
        this.$toast.info(
          `Contenuto del preventivo #${q.id} copiato. Inserisci un indirizzo diverso e salva.`
        );
      } catch (e) {
        this.$toast.error("Impossibile duplicare questo preventivo ora.");
      } finally {
        this.dupLoading = false;
      }
    },

    measureDescFrom(w, h) {
      const W = Number(w),
        H = Number(h);
      if (Number.isFinite(W) && Number.isFinite(H) && W > 0 && H > 0) {
        return `${W}×${H} cm`;
      }
      return null;
    },

    defaultOutstocks(n = 10) {
      return (this.outstocks || []).slice(0, n);
    },
    isOutstockTiles(row) {
      const it = this.getItemFromStore(
        row.itemId || row.outstockId,
        row.category
      );
      return (
        it &&
        it.category === "Fuori Magazzino" &&
        it.subCategory === "piastrelle"
      );
    },
    isStockTiles(row) {
      const it = this.getItemFromStore(
        row.itemId || row.outstockId,
        row.category
      );
      return it && it.category === "piastrelle";
    },
    qtyCell(row) {
      // Outstock piastrelle → nessuna quantità in pezzi/scatole da mostrare
      if (this.isOutstockTiles(row)) return "-"; // oppure "N/D"
      // Magazzino piastrelle → mostro le SCATOLE
      if (this.isStockTiles(row)) return Number(row.boxQuantity || 0);
      // Sanitari/altro → mostro i PEZZI
      return Number(row.pieces || row.quantity || 0);
    },

    // Anteprima "Venduti" (sc-47204): quantità venduta nativa + split magazzino/
    // da ordinare client-side. In modifica la disponibilità rilevante è
    // stockCorrente + warehouse già impegnato dalla riga (come fa il backend al save).
    // Per i fuori magazzino non esiste una quota "da magazzino": tutto è da
    // ordinare al fornitore, quindi il "0 da magazzino" sarebbe fuorviante.
    procureTitle(row) {
      const info = this.vendutiInfo(row);
      return row.outstockId
        ? `Fuori magazzino: ${info.procure} da ordinare al fornitore`
        : `${info.warehouse} da magazzino + ${info.procure} da ordinare`;
    },

    vendutiInfo(row) {
      // Fuori magazzino → nessuna disponibilità, tutto da ordinare
      if (row.outstockId) {
        const sold = Number(row.pieces || row.quantity || 0);
        return {
          sold,
          warehouse: 0,
          procure: sold,
          needsProcurement: sold > 0,
        };
      }
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      const isTiles = it.category === "piastrelle";
      const sold = isTiles
        ? Number(row.boxQuantity || 0)
        : Number(row.pieces || row.quantity || 0);
      const stock = isTiles
        ? Number(it.boxQuantity || 0)
        : Number(it.inWarehouse || 0);
      const oldWarehouse = Number(
        this.originalWarehouseByItemId[row.itemId] || 0
      );
      return { sold, ...splitQty(sold, stock + oldWarehouse) };
    },
    mqCell(row) {
      const it =
        this.getItemFromStore(row.itemId || row.outstockId, row.category) || {};
      // Magazzino piastrelle → scatole × mqPerBox
      if (this.isStockTiles(row)) {
        const sqmPerBox = Number(it.sqmPerBox) || 0;
        const boxes = Number(row.boxQuantity) || 0;
        const total = boxes * sqmPerBox;
        return total ? total.toFixed(2) : "N/D";
      }
      // Fuori magazzino piastrelle → i mq coincidono con 'pieces'
      if (this.isOutstockTiles(row)) {
        const sqm = Number(row.pieces) || 0;
        return sqm ? sqm.toFixed(2) : "N/D";
      }
      // Altri casi → non applicabile
      return "N/D";
    },

    categoryHintForRow(row) {
      if (row?.outstockId) return "Fuori Magazzino";
      if (row?.category) return row.category;
      return "STOCK";
    },

    getItemFromStore(id, categoryHint) {
      if (!id) return {};

      const isOut =
        categoryHint === "Fuori Magazzino" ||
        categoryHint === "OUT" ||
        categoryHint === "out" ||
        categoryHint === "outstock";

      const key = isOut ? KEY.OUT(id) : KEY.STOCK(id);

      // 1) usa la cache solo se l'ID combacia
      const cached = this.selectedByKey[key];
      if (cached && String(cached.id) === String(id)) {
        return cached;
      }

      // 2) cerca SOLO dove ha senso
      if (isOut) {
        const out =
          (this.outstocks || []).find((o) => o.id === id) ||
          (this.filteredOutstock || []).find((o) => o.id === id);
        if (out) {
          this.selectedByKey[key] = out;
          return out;
        }
        return {};
      }

      const stk =
        (this.items || []).find((i) => i.id === id) ||
        (this.filteredItems || []).find((i) => i.id === id);
      if (stk) {
        this.selectedByKey[key] = stk;
        return stk;
      }
      return {};
    },

    // Mappa l'azione updateQuote dallo store
    ...mapActions([
      "fetchQuotes",
      "updateQuote",
      "uploadQuoteDocument",
      "sendQuoteEmail",
    ]),

    // formatToDateTimeLocal,

    /* apertura/chiusura modale */
    openNewOutstockModal() {
      this.showNewOutstockModal = true;
    },
    closeNewOutstockModal() {
      // if (this.creatingOutstock) return;
      this.showNewOutstockModal = false;
      this.newOutstock = {
        subCategory: "",
        itemName: "",
        // sqmQuantity: null,
        sqmPrice: null,
        brand: "",
        subBrand: "",
        // quantity: null,
        price: null,
        widthCm: null,
        heightCm: null,
      };
    },

    /* crea outstock + selezione automatica + chiusura modale */
    async createNewOutstock() {
      const sub = this.newOutstock.subCategory;
      if (!this.isNewOutstockValid) {
        this.$toast.error("Compila correttamente i campi obbligatori.");
        return;
      }

      const isTiles = sub === "piastrelle";
      const w = this.newOutstock.widthCm;
      const h = this.newOutstock.heightCm;
      const mdesc = this.measureDescFrom(w, h);

      const payload = {
        category: "Fuori Magazzino",
        subCategory: sub,
        ...(isTiles
          ? {
              itemName: (this.newOutstock.itemName || "").trim(),
              sqmQuantity: 0,
              sqmPrice: Number(this.newOutstock.sqmPrice),
              measureDesc: mdesc,
              widthCm: w ?? null,
              heightCm: h ?? null,
            }
          : {
              brand: (this.newOutstock.brand || "").trim(),
              subBrand: (this.newOutstock.subBrand || "").trim(),
              quantity: 0,
              price: Number(this.newOutstock.price),
            }),
      };

      this.creatingOutstock = true;
      let save = false;
      try {
        let res;
        if (this.$store._actions?.createOutstock) {
          res = await this.$store.dispatch("createOutstock", payload);
        } else {
          res = await this.$axios.post(
            "outstock/create",
            JSON.stringify(payload)
          );
        }

        // dopo aver ottenuto res
        const created = res?.data?.outstock || res?.data || {};
        const createdId = created.id;

        try {
          const zeroPayload = isTiles ? { sqmQuantity: 0 } : { quantity: 0 };
          await this.updateOutstockQty(createdId, zeroPayload);
          await this.$store.dispatch("fetchOutstocks");
        } catch (e) {
          console.warn(
            "Inizializzazione qty=0 fallita:",
            e?.response?.data || e.message
          );
        }

        // aggiorna store e seleziona quello creato
        await this.$store.dispatch("fetchOutstocks");
        const fresh =
          (this.outstocks || []).find((o) => o.id === createdId) ||
          (this.outstocks || []).find((o) => {
            if (isTiles)
              return (
                (o.itemName || "") === payload.itemName &&
                Number(o.sqmPrice) === payload.sqmPrice
              );
            return (
              (o.brand || "") === payload.brand &&
              Number(o.price) === payload.price
            );
          });

        if (fresh) {
          this.selectOutstock(fresh); // imposta unitPrice, v-model, ecc.
          this.$toast.success("Articolo fuori magazzino creato!");
          save = true;
        } else {
          this.$toast.warning("Articolo creato, selezionalo dall’elenco.");
        }
        this.closeNewOutstockModal();
      } catch (err) {
        const msg =
          err?.response?.data?.details ||
          err?.response?.data?.error ||
          "Impossibile creare l’articolo.";
        this.$toast.error(msg);
      } finally {
        this.creatingOutstock = false;
        if (save) this.closeNewOutstockModal();
      }
    },

    selectItem(item) {
      this.newItem.itemId = item.id;

      const prezzoIvato = this.adjustedPrice(item.price, this.newItem.iva);
      this.searchQueryItem = itemPickerLabel(item);

      // cache namespaced
      this.selectedByKey[KEY.STOCK(item.id)] = item;

      // unitPrice = price (per stock mostri “prezzo unitario”)
      this.newItem.price = prezzoIvato;
      this.newItem.unitPrice = prezzoIvato;

      this.hideDropdown();
    },

    selectOutstock(outstock) {
      const iva = this.newItem.iva || 22;

      this.newItem = this.resetNewItem();
      this.newItem.outstockId = outstock.id;
      this.newItem.category = "Fuori Magazzino";
      this.newItem.iva = iva;

      // this.formData.outstockId = outstock.id;
      this.newItem.itemId = null;
      this.searchQueryItem = "";

      const base =
        outstock.subCategory === "piastrelle"
          ? Number(outstock.sqmPrice) || 0
          : Number(outstock.price) || 0;

      this.newItem.unitPrice = Number(
        this.adjustedPrice(base, this.newItem.iva)
      );

      // totale iniziale (qty 0 => 0, coerente con Create)
      const qtyNow = this.newItem.pieces || 0;
      this.newItem.price = (this.newItem.unitPrice * qtyNow).toFixed(2);

      const dim =
        outstock.measureDesc ||
        (outstock.widthCm && outstock.heightCm
          ? `${outstock.widthCm}×${outstock.heightCm} cm`
          : "");
      this.searchQueryOutstock = [outstockName(outstock), dim]
        .filter(Boolean)
        .join(" ")
        .trim();

      this.selectedByKey[KEY.OUT(outstock.id)] = outstock;
      this.hideDropdown();
    },

    async autoSaveDraft() {
      // Se non c'è ancora the quoteId (caricamento asincrono), aspettiamo
      if (!this.quoteId) return;

      // Se non c'è nulla di utile nel form (questo è meno comune in Edit, ma per sicurezza)
      const hasContent =
        this.formData.clientId || this.formData.items.length > 0;

      if (!hasContent) return;
      if (this.isSavingDraft) {
        this.needsReSave = true;
        return;
      }
      this.needsReSave = false;
      this.isSavingDraft = true;

      try {
        // Otteniamo sempre il nome completo e aggiornato per il draft
        let draftClientName = this.searchQueryClient;
        if (this.formData.clientId) {
          const allClients = this.clients || [];
          const c = allClients.find(
            (x) => String(x.id) === String(this.formData.clientId)
          );
          if (c) {
            draftClientName = this.getClientLabel(c);
            // Sincronizziamo anche l'interfaccia
            this.searchQueryClient = draftClientName;
          }
        }

        const payload = {
          payload: {
            ...this.formData,
            clientName: draftClientName,
          },
        };

        if (this.draftId) {
          await this.$axios.patch(`/draft/${this.draftId}`, payload);
        } else {
          payload.quoteId = this.quoteId; // Associa al preventivo esistente
          const { data } = await this.$axios.post("/draft/create", payload);
          if (data.draft?.id) {
            this.draftId = data.draft.id;
            this.$router.replace({
              query: { ...this.$route.query, draftId: this.draftId },
            });
          }
        }
      } catch (err) {
        console.error("Errore auto-salvataggio bozza (edit):", err);
      } finally {
        this.isSavingDraft = false;
        if (this.needsReSave) {
          // Se c'è stata una modifica durante il salvataggio, rilancia
          this.autoSaveDraft();
        } else {
          this.isAutoSavePending = false;
        }
      }
    },
    handleBeforeUnload(event) {
      if (this.isAutoSavePending) {
        event.preventDefault();
        event.returnValue = "";
      }
    },

    async loadDraft(id) {
      try {
        const { data } = await this.$axios.get(`/draft/${id}`);
        const draft = data.draft;
        if (draft && draft.payload) {
          this.formData = {
            ...this.formData,
            ...draft.payload,
          };
          this.$nextTick(() => {
            // carichiamo i dati nel form, poi il watcher 'clients' si occuperà di mostrare il testo corretto
          });
        }
      } catch (err) {
        this.$toast.error("Impossibile caricare la bozza");
        console.error(err);
      }
    },

    // --- helper: update singolo outstock ---
    handleOutstockSelection() {
      this.hideDropdown();
      const id = this.newItem.outstockId;
      const outstock = this.getItemFromStore(id, "Fuori Magazzino");
      if (outstock) this.selectOutstock(outstock);
    },

    async updateOutstockQty(id, payload) {
      try {
        if (this.$store._actions?.updateOutstock) {
          // ipotesi store: updateOutstock({ id, payload })
          await this.$store.dispatch("updateOutstock", { id, payload });
        } else {
          // fallback REST: PUT /outstock/update/:id  (adatta se diverso)
          await axiosInstance.patch(`/outstock/update/${id}`, payload);
        }
      } catch (e) {
        console.error("updateOutstockQty error", e);
        throw e;
      }
    },

    selectClient(client) {
      this.formData.clientId = client.id;
      this.searchQueryClient = client.clientName;
      this.hideDropdown();
    },

    startSearch(type) {
      this.activeSearch = type; // 'client' o 'item'
      this.showDropdown = true;
      this.selectedIndex = -1;

      // se parte una nuova ricerca resetta l’oggetto che stavi “editando”
      if (type === "item" || type === "outstock") {
        this.newItem = this.resetNewItem();
      }
      // azzera solo il campo “attivo”
      if (type === "client") this.searchQueryClient = "";
      if (type === "item") this.searchQueryItem = "";
      if (type === "outstock") this.searchQueryOutstock = "";

      if (type === "outstock") {
        if (!this.outstocks?.length) {
          // se vuoi forzare il fetch da API:
          // this.$store.dispatch("fetchOutstocks").finally(() => {
          //   this.filteredOutstock = this.defaultOutstocks();
          // });
        }
        this.filteredOutstock = this.defaultOutstocks();
      }
    },

    handleKey(event) {
      if (!this.showDropdown) return;

      // Quale array devo navigare?
      let list;
      if (this.activeSearch === "client") {
        list = this.filteredClients;
      } else if (this.activeSearch === "item") {
        list = this.filteredItems;
      } else if (this.activeSearch === "outstock") {
        list = this.filteredOutstock; // o filteredOutstock se disponibile
      } else {
        list = [];
      }

      // ========== freccia giù ==========
      if (event.key === "ArrowDown") {
        this.selectedIndex =
          this.selectedIndex < list.length - 1 ? this.selectedIndex + 1 : 0;
        event.preventDefault();

        // ========== freccia su ==========
      } else if (event.key === "ArrowUp") {
        this.selectedIndex =
          this.selectedIndex > 0 ? this.selectedIndex - 1 : list.length - 1;
        event.preventDefault();

        // ========== ENTER ==========
      } else if (event.key === "Enter") {
        if (this.selectedIndex >= 0 && this.selectedIndex < list.length) {
          const chosen = list[this.selectedIndex];

          if (this.activeSearch === "client") {
            // selezione cliente
            this.formData.clientId = chosen.id;
            this.searchQueryClient = chosen.clientName;
          } else if (this.activeSearch === "item") {
            // selezione articolo di magazzino
            this.newItem.itemId = chosen.id;
            this.searchQueryItem = itemPickerLabel(chosen);

            // cache namespaced
            this.selectedByKey[KEY.STOCK(chosen.id)] = chosen;

            // delega tutta la logica a onSelectItem (prezzo, iva, reset, ecc.)
            this.onSelectItem();
          } else if (this.activeSearch === "outstock") {
            // selezione outstock
            this.newItem.outstockId = chosen.id;
            this.selectOutstock(chosen); // calcolo unitPrice, reset campi, cache
          }
          this.showDropdown = false;
          this.selectedIndex = -1;
        }
        event.preventDefault();
      }
    },

    hideDropdown() {
      // Usa un timeout per permettere il click di selezione sul dropdown prima di nasconderlo
      setTimeout(() => {
        this.showDropdown = false;
        this.selectedIndex = -1;
        this.activeSearch = null; // Aggiungi questa linea per resettare l'indice
      }, 300);
    },

    adjustedPrice(listino, rate) {
      if (rate === 22) return listino;
      const regularPrice = (listino / 1.22).toFixed(2);
      const prezzoIvato = (regularPrice * (1 + rate / 100)).toFixed(2);
      return prezzoIvato;
    },

    /**
     * Gestisce la selezione di un articolo dal dropdown.
     * Chiude il dropdown e aggiorna la searchQuery con il nome dell'articolo selezionato.
     */
    // async onSelectItem() {
    //   this.hideDropdown();

    //   const chosenId = this.newItem.itemId;
    //   const item = this.getItemFromStore(chosenId, "STOCK");
    //   if (!item.id) return;

    //   // reset “pulito”, ma con la stessa IVA
    //   const iva = this.newItem.iva || 22;
    //   this.newItem = this.resetNewItem();
    //   this.newItem.itemId = chosenId;
    //   this.newItem.iva = iva;
    //   this.newItem.category = item.category || "";

    //   // disaccoppia l’altra selezione
    //   this.formData.outstockId = null;
    //   this.searchQueryOutstock = "";

    //   this.selectedItemById[item.id] = item;
    //   this.searchQueryItem = item.itemName
    //     ? `${item.itemName} ${item.measureDesc || ""}`.trim()
    //     : `${item.subBrand || ""} ${item.fixtureType || ""} ${
    //         item.fixturePosition || ""
    //       }`.trim();

    //   const prezzoIvato = this.adjustedPrice(item.price, this.newItem.iva);
    //   this.newItem.price = prezzoIvato;
    //   this.newItem.unitPrice = prezzoIvato;
    // },

    async onSelectItem() {
      this.hideDropdown();
      const chosenId = this.newItem.itemId;
      const item = this.getItemFromStore(chosenId, "STOCK");
      if (!item.id) return;

      const iva = this.newItem.iva || 22;
      this.newItem = this.resetNewItem();
      this.newItem.itemId = chosenId;
      this.newItem.iva = iva;
      this.newItem.category = item.category || "";

      this.newItem.outstockId = null;
      this.searchQueryOutstock = "";

      this.selectedByKey[KEY.STOCK(item.id)] = item;
      this.searchQueryItem = itemPickerLabel(item);

      const prezzoIvato = this.adjustedPrice(item.price, this.newItem.iva);
      this.newItem.price = prezzoIvato;
      this.newItem.unitPrice = prezzoIvato;
    },

    handleClientSelection() {
      this.showDropdown = false;
      this.searchQueryClient = this.getClientName(this.formData.clientId);
    },
    /**
     * Recupera i dati del preventivo da modificare.
     * Viene chiamato appena il componente è montato.
     */
    async fetchQuoteData() {
      try {
        this.errorMessage = "";
        const response = await axiosInstance.get(`/quote/${this.quoteId}`);
        // Adatta il percorso a seconda della tua API
        if (response.status === 200) {
          const quoteData = response.data.quote; // notare che i dati stanno sotto `quote`
          this.modificaChiusa = preventivoNonModificabile(quoteData);
          // console.log("fetchQuoteData quoteData", quoteData);
          // console.log("quoteData.response.data.quote", quoteData);
          // items viene dal server con item + item.QuoteItem
          // Creiamo un array "flat" con le proprietà necessarie
          // console.log("quoteData.quote_items", quoteData.quote_items);
          // mappa itemId → warehouse già impegnato (per anteprima split in modifica)
          const warehouseByItemId = {};
          (quoteData.quote_items || []).forEach((qi) => {
            if (qi.item && qi.item.id != null) {
              warehouseByItemId[qi.item.id] = Number(qi.quantityWarehouse || 0);
            }
          });
          this.originalWarehouseByItemId = warehouseByItemId;

          const mappedItems = (quoteData.quote_items || []).map((qi) => {
            if (qi.item) {
              // ───── articolo di magazzino ─────
              const it = qi.item;
              const isTiles = it.category === "piastrelle";

              return {
                itemId: it.id,
                outstockId: null,
                itemName: it.itemName || it.subBrand,
                category: it.category,
                boxQuantity: isTiles ? qi.quantity : 0,
                pieces: isTiles ? 0 : qi.quantity,
                price: Number(qi.price),
                iva: qi.iva,
              };
            } else {
              // ───── articolo FUORI magazzino ─────
              const os = qi.outstock;
              // const rightPrice =
              //   os.subCategory === "piastrelle" ? os.sqmPrice : os.price;

              return {
                itemId: null,
                outstockId: os.id, // ← SOLO l’id
                itemName: os.itemName,
                category: "Fuori Magazzino",
                quantity: qi.quantity,
                boxQuantity: 0,
                pieces: qi.quantity,
                price: Number(qi.price),
                iva: qi.iva,
              };
            }
          });

          // ⚠️ subito dopo const mappedItems = ...
          (quoteData.items || []).forEach((it) => {
            // sono articoli di MAGAZZINO
            if (it && it.id != null) {
              this.selectedByKey[KEY.STOCK(it.id)] = it;
            }
          });

          (quoteData.quote_items || []).forEach((qi) => {
            if (qi.item && qi.item.id != null) {
              // stock
              this.selectedByKey[KEY.STOCK(qi.item.id)] = {
                ...qi.item,
                // in certi dump itemName è "", ma brand/subBrand ci sono
                // non forziamo qui: ci pensa nameForDisplay al fallback
              };
            }
            if (qi.outstock && qi.outstock.id != null) {
              // fuori magazzino
              this.selectedByKey[KEY.OUT(qi.outstock.id)] = qi.outstock;
            }
          });

          this.formData.items = mappedItems;
          // console.log("this.formData.items", this.formData.items);
          this.formData.date = toDateTimeLocal(quoteData.date);

          // this.formData.date = this.formatToDateTimeLocal(quoteData.date);
          this.formData.clientId = quoteData.clientId || "";
          const c = (this.clients || []).find(
            (x) => x.id === this.formData.clientId
          );
          this.searchQueryClient = c
            ? this.getClientLabel(c)
            : quoteData.clientName || "";
          // this.searchQueryClient = quoteData.clientName || "";
          // this.formData.operatorId = quoteData.operatorId || "";

          // this.formData.eventName = quoteData.eventName || ""; // Se non esiste, assegna una stringa vuota

          // Se location non esiste, assegna un oggetto vuoto
          // this.formData.location = asLoc(quoteData.location) || {
          //   name: "",
          //   address: "",
          //   placeId: "",
          //   latitude: "",
          //   longitude: "",
          // };

          const normLoc = this.normalizeLocFromApi(quoteData.location);
          this.formData.location = normLoc;
          this.formData.payment_method = quoteData.payment_method;
          this.formData.technical_queries = quoteData.technical_queries || "";
          this.$nextTick(() => {
            this.successMessage = `Dati del preventivo con ID:${this.quoteId} caricati con successo`;
            this.$toast.success(this.successMessage);
            this.captureSnapshot(); // stato iniziale caricato
          });
        }
      } catch (error) {
        // console.error("fetchQuoteData error:", error);
        this.errorMessage =
          error.response?.data?.message ||
          "Impossibile caricare i dati del preventivo.";
        this.$toast.error(this.errorMessage);
      }
    },

    toggleItemsList() {
      this.showItemsList = !this.showItemsList;
    },

    addOrUpdateItem() {
      this.errorMessage = "";
      this.successMessage = "";

      const isTile = this.selectedItem.category === "piastrelle";
      const isOutstock = !!this.newItem.outstockId;

      // stock piastrelle: qty = scatole; tutti gli altri (incluso outstock piastrelle): qty = pieces (mq o pezzi)
      const qty = isTile
        ? Number(this.newItem.boxQuantity || 0)
        : Number(this.newItem.pieces || 0);

      if (
        (!this.newItem.itemId && !isOutstock) ||
        qty <= 0 ||
        !this.newItem.unitPrice
      ) {
        this.$nextTick(() => {
          this.errorMessage =
            "Compila tutti i campi prima di aggiungere un articolo.";
          this.$toast.error(this.errorMessage);
        });
        return;
      }

      const fullId = this.newItem.itemId || this.newItem.outstockId;
      const full = this.getItemFromStore(
        fullId,
        this.categoryHintForRow(this.newItem)
      );
      // if (full.id) this.selectedItemById[full.id] = full;
      if (full.id)
        this.selectedByKey[
          this.newItem.itemId ? KEY.STOCK(full.id) : KEY.OUT(full.id)
        ] = full;

      const existing = this.formData.items.find((r) =>
        isOutstock
          ? r.outstockId === this.newItem.outstockId
          : r.itemId === this.newItem.itemId
      );

      if (existing) {
        if (isTile) {
          existing.boxQuantity = this.newItem.boxQuantity;
          existing.pieces = 0;
        } else {
          existing.pieces = this.newItem.pieces; // sanitari / outstock (piastrelle = mq)
        }
        existing.unitPrice = this.newItem.unitPrice; // prezzo unitario
        existing.price = this.newItem.unitPrice;
        existing.quantity = existing.pieces || existing.boxQuantity;
        existing.iva = this.newItem.iva;

        this.$nextTick(() => {
          this.successMessage = "Quantità aggiornata per l'articolo esistente.";
          this.$toast.success(this.successMessage);
        });
        return;
      }

      // nuova riga
      this.formData.items.push({
        itemId: this.newItem.itemId,
        outstockId: this.newItem.outstockId,
        category: this.newItem.category || this.selectedItem.category,
        boxQuantity: isTile ? this.newItem.boxQuantity : 0,
        pieces: isTile ? 0 : this.newItem.pieces, // outstock piastrelle: mq qui
        quantity: isTile ? this.newItem.boxQuantity : this.newItem.pieces,
        unitPrice: this.newItem.unitPrice, // prezzo unitario
        price: this.newItem.unitPrice,
        iva: this.newItem.iva,
      });

      this.$nextTick(() => {
        this.successMessage = "Articolo aggiunto con successo.";
        this.$toast.success(this.successMessage);
      });

      this.newItem = this.resetNewItem();
      this.searchQueryItem = "";
      this.searchQueryOutstock = "";
      this.showDropdown = false;
      // this.newItem.itemId = null;
      // this.formData.outstockId = null;
    },

    // sc-48743: cambio IVA dalla riga. Il prezzo unitario ivato si ricalcola
    // a parità di imponibile, come fa il form quando si sceglie l'aliquota.
    updateRowIva(idx, rawValue) {
      const nuova = Number(rawValue);
      const item = { ...this.formData.items[idx] };
      const attuale = Number(item.iva ?? 22);
      if (!ALIQUOTE_IVA.includes(nuova) || nuova === attuale) return;
      const prezzo = prezzoConIva(item.unitPrice ?? item.price, attuale, nuova);
      item.iva = nuova;
      item.price = prezzo;
      if (item.unitPrice !== undefined) item.unitPrice = prezzo;
      this.formData.items.splice(idx, 1, item);
    },

    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    startQtyEdit(idx, currentValue) {
      const orig = Number(currentValue);
      this.editingQty = { idx, value: orig, originalValue: orig };
      this.$nextTick(() => {
        const ref = this.$refs[`qtyInput_${idx}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el && typeof el.focus === "function") el.focus();
      });
    },

    updateQtyLive(idx, rawValue) {
      const val = parseFloat(rawValue);
      if (isNaN(val) || val <= 0) return;
      const item = { ...this.formData.items[idx] };
      if (this.isStockTiles(item)) {
        item.boxQuantity = val;
      } else {
        item.pieces = val;
      }
      this.formData.items.splice(idx, 1, item);
    },

    closeQtyEdit() {
      this.editingQty = { idx: null, value: null, originalValue: null };
    },

    cancelQtyEdit() {
      const { idx, originalValue } = this.editingQty;
      if (idx !== null && originalValue !== null) {
        const item = { ...this.formData.items[idx] };
        if (this.isStockTiles(item)) {
          item.boxQuantity = originalValue;
        } else {
          item.pieces = originalValue;
        }
        this.formData.items.splice(idx, 1, item);
      }
      this.editingQty = { idx: null, value: null, originalValue: null };
    },

    saveToLocalStorage(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },

    loadFromLocalStorage(key) {
      const savedData = localStorage.getItem(key);
      if (savedData) {
        return JSON.parse(savedData);
      }
      return null;
    },

    getItemName(id, category) {
      if (!id) return "Sconosciuto";
      const src = this.getItemFromStore(id, category);
      if (src && src.id != null) return this.nameForDisplay(src);

      // 🔚 ultima spiaggia: usa la riga già mappata in formData.items
      const row = (this.formData.items || []).find(
        (r) => (category === "Fuori Magazzino" ? r.outstockId : r.itemId) === id
      );
      if (row) {
        // per sanitari/altro la mappatura include almeno itemName (o subBrand)
        return row.itemName || "Sconosciuto";
      }
      return "Sconosciuto";
    },

    getClientName(clientId) {
      const client = this.clients.find((c) => c.id === clientId);
      return client ? client.clientName : "Sconosciuto";
    },

    getClientLabel(c) {
      if (!c) return "";
      const email = c?.email;
      const pec = c?.pec;
      return email
        ? `${c.clientName} - (${email})`
        : `${c.clientName} - (${pec || "—"})`;
    },

    formatPrice(price) {
      // console.log("beforeFormatPrice price", price);
      const currencySymbol = "€"; // Cambia in "$" per il dollaro
      return `${currencySymbol} ${parseFloat(price).toFixed(2)}`;
    },

    unitForRow(row) {
      const it =
        this.getItemFromStore(row.itemId || row.outstockId, row.category) || {};
      const isStockTiles = it.category === "piastrelle";
      const isOutTiles =
        it.category === "Fuori Magazzino" && it.subCategory === "piastrelle";
      if (
        String(row?.itemName || it?.itemName || "")
          .toLowerCase()
          .includes("battiscopa")
      )
        return "€/mL";
      return isStockTiles || isOutTiles ? "€/mq" : "€/pz";
    },

    // mqForRow(row) {
    //   // console.log("row", row);
    //   const item = this.getItemFromStore(
    //     row.itemId || row.outstockId,
    //     row.category
    //   );
    //   // console.log("mqForRow item", item);
    //   // solo piastrelle
    //   if (item.category !== "piastrelle" && item.subCategory === "piastrelle") {
    //     return row.pieces;
    //   }
    //   const sqmPerBox = Number(item.sqmPerBox) || 0;
    //   const boxes = Number(row.boxQuantity) || 0;
    //   const total = sqmPerBox * boxes;
    //   return total ? total.toFixed(2) : "";
    // },

    mqForRow(row) {
      const it =
        this.getItemFromStore(row.itemId || row.outstockId, row.category) || {};

      // Stock piastrelle: scatole × mqPerBox
      if (it.category === "piastrelle") {
        const sqmPerBox = Number(it.sqmPerBox) || 0;
        const boxes = Number(row.boxQuantity) || 0;
        const total = sqmPerBox * boxes;
        return total ? total.toFixed(2) : "N/D";
      }

      // Fuori magazzino piastrelle: i mq coincidono con 'pieces'
      if (
        it.category === "Fuori Magazzino" &&
        it.subCategory === "piastrelle"
      ) {
        const sqm = Number(row.pieces) || 0;
        return sqm ? sqm.toFixed(2) : "N/D";
      }

      // Altri casi
      return "N/D";
    },

    resetNewItem() {
      return {
        itemId: null,
        outstockId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        unitPrice: 0, // prezzo unitario per articoli fuori magazzino
        category: "",
        quantity: 0, // quantità pezzi per articoli fuori magazzino
        iva: 22,
      };
    },

    buildQuoteTable(quote, pageWidth, marginX) {
      // quote = updatedQuote (ha quote_items con .item o .outstock)
      const head = [
        [
          "Cod.",
          "Descrizione",
          "Scatole",
          "Q.tà",
          "U.m.",
          "Prezzo ivato",
          "Iva",
          "Importo ivato",
        ],
      ];
      const body = [];
      const righeIva = []; // per l'imponibile del riepilogo (sc-48721)
      // console.log("quote", quote.quote_items);
      // Raggruppo per categoria (opzionale; se non vuoi gruppi, rimuovi la parte "header di sezione")
      const groups = (quote.quote_items || []).reduce((acc, qi) => {
        const cat = (
          qi.item?.category ||
          qi.outstock?.category ||
          "generale"
        ).toUpperCase();
        (acc[cat] = acc[cat] || []).push(qi);
        return acc;
      }, {});

      Object.entries(groups).forEach(([cat, list]) => {
        // riga header di sezione (se non la vuoi, commenta questo push)
        body.push([
          {
            content: cat,
            colSpan: 8,
            styles: {
              fillColor: [235, 235, 235],
              fontStyle: "bold",
              halign: "left",
            },
          },
        ]);

        list.forEach((qi) => {
          const isStockTiles = qi.item?.category === "piastrelle";
          const isOutTiles = qi.outstock?.subCategory === "piastrelle";
          const isTiles = isStockTiles || isOutTiles;
          const boxes = isStockTiles ? Number(qi.quantity || 0) : "";

          // qty
          let qty;
          // sc-48721: l'importo usa i mQ pieni, come totalPrice dell'API; la
          // Q.tà mostrata resta arrotondata. Altrimenti la somma della tabella
          // non torna col totale (es. 1 scatola da 1.5376 mQ).
          let qtyPiena;
          if (isStockTiles) {
            const sqmPerBox = Number(qi.item?.sqmPerBox || 0);
            qtyPiena = sqmPerBox
              ? sqmPerBox * Number(qi.quantity || 0)
              : Number(qi.quantity || 0);
            qty = Number(qtyPiena.toFixed(2));
          } else {
            qty = Number(qi.quantity || 0);
            qtyPiena = qty;
          }

          // descrizione: titolo + tipo/posizione per i sanitari (sc-48197)
          const src = qi.item || qi.outstock || {};
          const desc = itemFullDescription(src) || this.nameForDisplay(src);

          // unit
          const unit = String(desc).toLowerCase().includes("battiscopa")
            ? "mL"
            : isTiles
            ? "mQ"
            : "pz";

          const unitPrice = Number(qi.price || 0);
          const iva = Number(qi.iva ?? 22);
          const lineTotal = Number((unitPrice * qtyPiena).toFixed(2));
          righeIva.push({ importo: lineTotal, iva });

          body.push([
            qi.item?.code ?? "-", // Cod.
            desc, // Descrizione
            boxes === "" ? "" : String(boxes), // Scatole
            String(qty), // Q.tà
            unit, // U.m.
            `€ ${unitPrice.toFixed(2)}`, // Prezzo ivato
            `${iva}%`, // Iva
            `€ ${lineTotal.toFixed(2)}`, // Importo ivato
          ]);
        });
      });

      // larghezze (desc AUTO)
      const usable = pageWidth - 2 * marginX;
      const w = {
        cod: 0.1,
        box: 0.11,
        qty: 0.1,
        um: 0.08,
        price: 0.16,
        iva: 0.08,
        tot: 0.17, // sc-48721: con Descrizione a min 40 mm la tabella resta di 190 mm
      };
      const cw = {
        0: Math.floor(usable * w.cod), // Cod.
        2: Math.floor(usable * w.box), // Scatole
        3: Math.floor(usable * w.qty), // Q.tà
        4: Math.floor(usable * w.um), // U.m.
        5: Math.floor(usable * w.price), // Prezzo
        6: Math.floor(usable * w.iva), // Iva
        7: Math.floor(usable * w.tot), // Tot
      };

      return {
        // La descrizione passa da nameForDisplay(), che unisce i campi con " -> ".
        // pdfSafeRows riporta il separatore e i dati DB dentro cp1252: senza,
        // jsPDF emette l'intera cella in UTF-16BE e il PDF esce corrotto.
        head: pdfSafeRows(head),
        body: pdfSafeRows(body),
        imponibile: totaliImponibile(righeIva),
        tableWidth: usable,
        margin: { left: marginX, right: marginX },
        columnStyles: {
          0: { cellWidth: cw[0], halign: "left" }, // Cod.
          1: { cellWidth: "auto", minCellWidth: 40 }, // Descrizione (AUTO)
          2: { cellWidth: cw[2], halign: "right" }, // Scatole
          3: { cellWidth: cw[3], halign: "right" }, // Q.tà
          4: { cellWidth: cw[4], halign: "center" }, // U.m.
          5: { cellWidth: cw[5], halign: "right" }, // Prezzo
          6: { cellWidth: cw[6], halign: "right" }, // Iva
          7: { cellWidth: cw[7], halign: "right" }, // Tot
        },
      };
    },

    async onUpdateQuoteAndGeneratePdf({
      sendEmail = false,
      skipUpdate = false,
    } = {}) {
      // 1. Cancelliamo eventuali auto-salvataggi pendenti
      if (typeof this.debouncedAutoSave?.cancel === "function") {
        this.debouncedAutoSave.cancel();
      }
      this.isAutoSavePending = false;

      this.errorMessage = "";
      this.successMessage = "";

      // 0) Validazione base
      if (!(this.formData.location?.address || "").trim()) {
        this.$toast.error("Inserisci un indirizzo di consegna.");
        return;
      }
      if (this.formData.items.length === 0) {
        this.$nextTick(() => {
          this.errorMessage = "Aggiungi almeno un articolo prima di salvare";
          this.$toast.error(this.errorMessage);
        });
        return;
      }

      try {
        // 1) pulizia item “in input” se presente
        if (
          (this.newItem.itemId || this.newItem.outstockId) &&
          (this.newItem.boxQuantity ||
            this.newItem.pieces ||
            this.newItem.quantity)
        ) {
          this.formData.items.push({ ...this.newItem });
        }

        // 2) costruisci items per API con coercizioni sicure
        const apiItems = this.formData.items.map((row) => {
          const isOut = row.category === "Fuori Magazzino";
          const qty = isOut
            ? this.cleanNumber(row.pieces || row.quantity, { min: 0 })
            : this.cleanNumber(row.boxQuantity || row.pieces, { min: 0 });
          return {
            outstockId: isOut ? row.outstockId : null,
            itemId: isOut ? null : row.itemId,
            quantity: qty,
            price: this.cleanNumber(row.unitPrice ?? row.price, { min: 0 }), // prezzo unitario ivato
            iva: this.cleanNumber(row.iva ?? 22, { min: 0 }),
            category: row.category || "",
          };
        });

        // 3) payload base
        let payload = {
          ...this.formData,
          items: apiItems,
          draftId: this.draftId,
          sendEmail, // Flag per l'invio email al cliente
        };

        // 4) sanitize campi testuali
        payload.payment_method = (payload.payment_method || "").trim();
        payload.technical_queries = this.sanitizeStr(
          payload.technical_queries,
          { maxLen: 8000 }
        );

        // 5) location opzionale + normalizzazione
        if (payload.location) {
          payload.location = this.normalizeLocFromApi(payload.location);
          if (!(payload.location.address || "").trim()) {
            delete payload.location;
          }
        }

        // 6) client coerente
        payload.clientId =
          payload.clientId === "" || payload.clientId == null
            ? null
            : Number(payload.clientId);

        // 7) rimuovi duplicati nel payload (difesa ulteriore)
        const keyOf = (r) => `${r.itemId ?? ""}|${r.outstockId ?? ""}`;
        const seen = new Set();
        payload.items = payload.items.filter((r) => {
          const k = keyOf(r);
          if (seen.has(k)) return false;
          seen.add(k);
          return true;
        });

        // console.log("PAYLOAD:", JSON.stringify(payload, null, 2));

        let quote;
        let response;
        if (!skipUpdate) {
          // => Update preventivo
          response = await this.updateQuote({
            quoteId: this.quoteId,
            payload,
          });
          this.response = response;

          if (response?.status !== 200 && response?.status !== 201) {
            // ⬇️ ramo 409
            if (
              response?.status === 409 &&
              response?.data.code === "QUOTE_DUPLICATE"
            ) {
              const d = response?.data || {}; // usa quello che hai a disposizione
              const details =
                (typeof d.details === "object" && d.details) || {};
              const id = details.quoteId ?? d.quoteId ?? null;
              const address =
                details.address ?? this.formData?.location?.address ?? null;
              const msg =
                d.message ||
                d.details ||
                "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso...";

              this.$toast.error(msg);
              this.openDuplicateModal(id, address);
              return;
            }

            // ...altri errori
            this.errorMessage =
              response.data?.details ||
              response.data?.message ||
              "Impossibile aggiornare il preventivo.";
            this.$toast.error(this.errorMessage);
            this.successMessage = "";
            return;
          }
          const quoteWrap = response?.data?.quote || {};
          quote = quoteWrap.updatedQuote;
        } else {
          // Solo invio: carichiamo i dati correnti dal server
          this.$toast.info("Recupero dati per invio email...");
          const res = await axiosInstance.get(`/quote/${this.quoteId}`);
          quote = res.data.quote;
          // In questo caso fittiziamo una "response" minima per il PDF logic
          response = { data: { quote: { updatedQuote: quote } } };
        }

        // 4) Aggiorna stato locale post-update
        const { updatedQuote, totalPrice } = response.data.quote;
        this.formData.totalPrice = Number(totalPrice);

        // Rimappa gli items per la tabella
        this.formData.items = (updatedQuote.quote_items || []).map((qi) => {
          if (qi.item) {
            // item di magazzino
            const it = qi.item;
            const isTiles = it.category === "piastrelle";
            return {
              itemId: it.id,
              outstockId: null,
              itemName: it.itemName || it.subBrand,
              category: it.category,
              boxQuantity: isTiles ? qi.quantity : 0,
              pieces: isTiles ? 0 : qi.quantity,
              sqmPerBox: isTiles ? Number(it.sqmPerBox) || 0 : 0,
              price: Number(qi.price),
              iva: qi.iva,
            };
          }
          // fuori magazzino
          const os = qi.outstock;
          return {
            itemId: null,
            outstockId: os.id,
            itemName: os.itemName,
            category: os.category, // "Fuori Magazzino"
            boxQuantity: 0,
            pieces: qi.quantity,
            sqmPerBox: 0,
            price: Number(qi.price),
            iva: qi.iva,
          };
        });

        // Aspettiamo che Vue 2 flushi i watcher asincroni (accodati dalla mutazione sopra),
        // poi nel secondo $nextTick siamo certi di essere dopo tutti i flush
        await this.$nextTick();
        await this.$nextTick();

        // Annulliamo eventuale debouncedAutoSave rischedulato dal watcher durante il flush
        if (typeof this.debouncedAutoSave?.cancel === "function") {
          this.debouncedAutoSave.cancel();
        }
        this.captureSnapshot(); // stato aggiornato salvato
        this.isDraftDirty = false; // Reset definitivo: siamo sicuri di essere post-watcher
        this.hasSavedInSession = true;
        this.isPdfGenerated = true; // PDF disponibile
        this.isAutoSavePending = false; // Nessun auto-salvataggio pendente

        this.$nextTick(() => {
          this.successMessage =
            response.data.message || "Preventivo aggiornato con successo!";
          this.$toast.success(this.successMessage);
        });

        // 5) Genera + carica + salva il PDF (logica tua consolidata)
        // ----------------------------------------------------------
        const doc = new jsPDF({ unit: "mm", format: "a4" });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginX = 10;
        const marginY = 10;
        let y = marginY;

        const total = parseFloat(
          response?.data?.quote?.totalPrice ?? quote?.totalPrice ?? 0
        );
        const quoteClient =
          quote.Client ||
          this.clients.find(
            (c) =>
              String(c.id) === String(quote.clientId) ||
              String(c.id) === String(this.formData.clientId)
          ) ||
          null;
        const contactValue = quoteClient?.pec || quoteClient?.email || "";
        const contactLabel = quoteClient?.pec ? "pec" : "email";

        // — Logo + intestazione
        if (this.image) {
          try {
            doc.addImage(this.image, "PNG", marginX, y, 30, 30);
          } catch (err) {
            // console.error("Logo non caricato", err);
          }
        }
        doc.setFontSize(9).setFont("helvetica", "normal");
        const headerLines = [
          "VIA SIRACUSA 83 - 96012  AVOLA  (SR)  - ITALIA ",
          "Tel. 3492253528 / 0931822066",
          "Email: emmamaison@libero.it",
        ];
        let headerY = y + 5;
        headerLines.forEach((text) => {
          const x = pageWidth - marginX - doc.getTextWidth(text);
          doc.text(text, x, headerY);
          headerY += 4;
        });
        y += 48;

        const printLabelValue = (label, value, xPos, yPos, maxWidth = null) => {
          doc.setFont("helvetica", "bolditalic");
          doc.text(`${label}:`, xPos, yPos);
          const offset = doc.getTextWidth(`${label}: `) + 0.8;
          doc.setFont("helvetica", "normal");
          // pdfSafe: i dati cliente arrivano dal DB senza sanificazione lato API
          const val = pdfSafe(value, { fallback: "N/D" });
          if (maxWidth) {
            const wrapped = doc.splitTextToSize(val, maxWidth - offset);
            wrapped.forEach((ln, idx) =>
              doc.text(ln, xPos + offset, yPos + idx * 5)
            );
            return yPos + wrapped.length * 5;
          } else {
            doc.text(val, xPos + offset, yPos);
            return yPos + 5;
          }
        };

        // — Dettaglio cliente (SX)
        const leftX = marginX;
        doc
          .setFontSize(14)
          .setFont("helvetica", "bold")
          .text("Dettaglio cliente", leftX, y);
        let yLeft = y + 8;
        doc.setFontSize(11);
        const lh = (() => {
          const raw = quoteClient?.legalHeadquarters;
          if (!raw) return {};
          if (typeof raw === "object") return raw;
          try {
            return JSON.parse(raw);
          } catch {
            return {};
          }
        })();
        yLeft = printLabelValue(
          "codice cliente",
          quoteClient?.uniqueCode,
          leftX,
          yLeft
        );
        yLeft = printLabelValue(
          "cliente",
          quoteClient?.clientName,
          leftX,
          yLeft
        );
        yLeft = printLabelValue(
          "telefono",
          quoteClient?.phoneNumber,
          leftX,
          yLeft
        );
        yLeft = printLabelValue(contactLabel, contactValue, leftX, yLeft);
        yLeft = printLabelValue(
          "partita iva",
          quoteClient?.vatNumber,
          leftX,
          yLeft
        );
        yLeft = printLabelValue(
          "codice fiscale",
          quoteClient?.taxCode,
          leftX,
          yLeft
        );
        yLeft = printLabelValue(
          "azienda",
          quoteClient?.companyName,
          leftX,
          yLeft
        );
        yLeft = printLabelValue(
          "sede legale",
          lh.address,
          leftX,
          yLeft,
          pageWidth / 2 - 20
        );

        // — Dettaglio preventivo (DX)
        const rightX = pageWidth / 2 + 10;
        const colW = pageWidth - rightX - marginX;
        const formattedDate = new Date(quote.date).toLocaleDateString("it-IT", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        doc
          .setFontSize(14)
          .setFont("helvetica", "bold")
          .text("Dettaglio preventivo", rightX, y);
        let yRight = y + 8;
        doc.setFontSize(11);
        const loc = asLoc(quote.location) || {};
        yRight = printLabelValue("data", formattedDate, rightX, yRight);
        yRight = printLabelValue(
          "indirizzo di consegna",
          loc.address,
          rightX,
          yRight,
          colW
        );
        if (loc.link) {
          doc.setFont("helvetica", "bolditalic");
          doc.text("maps:", rightX, yRight);
          const off = doc.getTextWidth("maps: ") + 0.8;
          doc
            .setFont("helvetica", "bold")
            .setFontSize(10)
            .setTextColor(0, 0, 255);
          const safeLink = pdfSafe(loc.link);
          const disp =
            doc.getTextWidth(safeLink) > colW - off
              ? safeLink.slice(8, 27) + "…"
              : safeLink;
          doc.textWithLink(disp, rightX + off, yRight, { url: loc.link });
          doc.setTextColor(0).setFontSize(11).setFont("helvetica", "normal");
          yRight += 5;
        }

        y = Math.max(yLeft, yRight) + 4;
        doc.setDrawColor(150).line(marginX, y, pageWidth - marginX, y);
        y += 6;

        // — Tabella articoli (usa helper)
        const tbl = this.buildQuoteTable(quote, pageWidth, marginX);
        autoTable(doc, {
          startY: y,
          theme: "grid",
          styles: { fontSize: 10, cellPadding: 1.5 },
          headStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
          head: tbl.head,
          body: tbl.body,
          columnStyles: tbl.columnStyles,
          tableWidth: tbl.tableWidth,
          margin: tbl.margin,
        });
        y = (doc.lastAutoTable?.finalY || y) + 10;

        // — Riepilogo come un conto (sc-48721). Stessa regola di QuotePage:
        // prima leggeva quote.percent e trattava discount_percent come euro.
        const footerBlockGuard = 55;
        if (pageHeight - y < footerBlockGuard) {
          doc.addPage();
          y = marginY;
        }
        y = disegnaRiquadroRiepilogo(doc, {
          y,
          pageWidth,
          marginX,
          righe: righeRiepilogo(
            calcolaImporti({ ...quote, totalPrice: total }),
            tbl.imponibile
          ),
        });

        if (quote.technical_queries) {
          if (pageHeight - y < 20) {
            doc.addPage();
            y = marginY;
          }
          doc.setFont("helvetica", "italic").setFontSize(8);
          // Note libere: e' il campo piu' esposto a testo incollato da Word/web
          const txt = doc.splitTextToSize(
            pdfSafe(quote.technical_queries),
            pageWidth - 2 * marginX
          );
          doc.text(txt, marginX, y);
        }

        // 6) Upload + salvataggio locale
        const quoteId = quote.id;
        const filenameBase = `Preventivo_N_${quoteId}.pdf`;
        const isDev =
          process.env.NODE_ENV === "development" ||
          import.meta?.env?.MODE === "development" ||
          process.env?.VUE_APP_NODE_ENV === "development";

        // helper FE (senza 'path')
        const withSuffixBeforeExt = (filename, suffix) => {
          if (!suffix) return filename;
          const dot = filename.lastIndexOf(".");
          if (dot <= 0) return `${filename}.${suffix}`;
          return `${filename.slice(0, dot)}.${suffix}${filename.slice(dot)}`;
        };

        const finalName = withSuffixBeforeExt(filenameBase, isDev ? "dev" : "");
        const blob = doc.output("blob");
        // 👇 crea un "File" con nome giusto, così Multer lo vede come originalname
        const file = new File([blob], finalName, { type: "application/pdf" });

        try {
          const uploadResp = await this.$store.dispatch("uploadQuoteDocument", {
            quoteId,
            document: file,
            filename: finalName,
          });
          this.lastUploadedDocName = uploadResp.data.doc.name;
        } catch (error) {
          console.error("Errore durante l'upload del PDF:", error);
          this.$toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante il caricamento del PDF."
          );
          return;
        }

        // Scarica sempre il PDF localmente
        doc.save(finalName);
      } catch (error) {
        // console.error("Errore durante l'aggiornamento del preventivo:", error);
        const resp = error?.response;

        // ⬇️ ramo 409
        if (resp?.status === 409 && resp?.data?.code === "QUOTE_DUPLICATE") {
          const d = resp?.data || {}; // usa quello che hai a disposizione
          const details = (typeof d.details === "object" && d.details) || {};
          const id = details.quoteId ?? d.quoteId ?? null;
          const address =
            details.address ?? this.formData?.location?.address ?? null;
          const msg =
            d.message ||
            d.details ||
            "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso...";

          this.$toast.error(msg);
          this.openDuplicateModal(id, address);
          return;
        }

        // ...altri errori
        this.errorMessage =
          resp?.data?.message ||
          resp?.data?.details ||
          resp?.data?.error ||
          "Errore durante l'aggiornamento del preventivo.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
      }
    },

    fetchItems(q) {
      axiosInstance
        .get("/item/get-all", { params: { page: 1, limit: 10, search: q } })
        .then(({ data }) => {
          this.filteredItems = data.results;
        })
        .catch(console.error);
    },
    fetchOutstocks(q) {
      axiosInstance
        .get("/outstock/get-all", { params: { page: 1, limit: 10, search: q } })
        .then(({ data }) => {
          this.filteredOutstock = data.results;
        })
        .catch(console.error);
    },

    // --- pulizia selezione articolo di magazzino ---
    clearItemSelection() {
      const iva = this.newItem.iva || 22; // preserva l'IVA scelta
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      this.searchQueryItem = "";
    },

    // --- pulizia selezione fuori magazzino ---
    clearOutstockSelection() {
      const iva = this.newItem.iva || 22;
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      // this.formData.outstockId = null;
      this.searchQueryOutstock = "";
    },
  },

  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (typeof this.debouncedFetchItems?.cancel === "function") {
      this.debouncedFetchItems.cancel();
    }
    if (typeof this.debouncedFetchOutstocks?.cancel === "function") {
      this.debouncedFetchOutstocks.cancel();
    }
    if (typeof this.debouncedAutoSave?.cancel === "function") {
      this.debouncedAutoSave.cancel();
    }
  },

  watch: {
    formData: {
      handler() {
        this.isDraftDirty = true;
        this.isPdfGenerated = false; // Le modifiche invalidano il PDF generato
        this.isAutoSavePending = true;
        this.debouncedAutoSave();
      },
      deep: true,
    },
    "formData.clientId": {
      immediate: true,
      handler(newId) {
        if (newId) {
          const c = (this.clients || []).find(
            (x) => String(x.id) === String(newId)
          );
          if (c) this.searchQueryClient = this.getClientLabel(c);
        }
      },
    },
    clients: {
      immediate: true,
      handler(newList) {
        if (this.formData.clientId) {
          const c = (newList || []).find(
            (x) => String(x.id) === String(this.formData.clientId)
          );
          if (c) this.searchQueryClient = this.getClientLabel(c);
        }
      },
    },
    searchQueryClient() {
      this.isAutoSavePending = true;
      this.debouncedAutoSave();
    },

    showDuplicateModal(v) {
      if (v && this.lastDuplicateQuoteInfo?.quoteId) this.loadDuplicateQuote();
    },
    lastDuplicateQuoteInfo: {
      deep: true,
      handler(nv) {
        if (this.showDuplicateModal && nv?.quoteId) this.loadDuplicateQuote();
      },
    },

    // 🔎 Articoli di magazzino
    searchQueryItem(newQ, oldQ) {
      // se l'utente cancella il testo ed è presente una selezione → pulisci e riabilita l'altro input
      if (oldQ && !newQ.trim() && this.newItem.itemId)
        this.clearItemSelection();

      if (!newQ.trim()) {
        // niente testo: torna ai primi articoli (get-all senza filtro)
        this.debouncedFetchItems("");
        return;
      }
      this.debouncedFetchItems(newQ);
    },

    // 🔎 Articoli fuori magazzino
    searchQueryOutstock(newQ, oldQ) {
      if (oldQ && !newQ.trim() && this.newItem.outstockId)
        this.clearOutstockSelection();

      if (!newQ.trim()) {
        this.filteredOutstock = this.defaultOutstocks();
        return;
      }
      this.debouncedFetchOutstocks(newQ);
    },

    // watch per svuotare i campi quando si cambia la sottocategoria
    "newOutstock.subCategory"(val) {
      if (val === "piastrelle") {
        // pulisci campi non pertinenti
        this.newOutstock.brand = "";
        this.newOutstock.subBrand = "";
        // this.newOutstock.quantity = null;
        this.newOutstock.price = null;
      } else if (val === "sanitari" || val === "altro") {
        this.newOutstock.itemName = "";
        // this.newOutstock.sqmQuantity = null;
        this.newOutstock.sqmPrice = null;
        this.newOutstock.widthCm = null;
        this.newOutstock.heightCm = null;
      }
    },

    // 🔒 mutua esclusione (come già facevi)
    "newItem.itemId"(v) {
      if (v) {
        this.newItem.outstockId = null;
        this.searchQueryOutstock = "";
      }
    },
    "newItem.outstockId"(v) {
      if (v) {
        this.newItem.itemId = null;
        this.searchQueryItem = "";
      }
    },

    // "formData.outstockId"(v) {
    //   if (!v) return;
    //   this.newItem.outstockId = v;
    //   this.newItem.itemId = null;
    // },

    // 💶 ricalcolo prezzo al cambio IVA (invariato salvo minimi ritocchi)
    // "newItem.iva"(val) {
    //   if (this.newItem.itemId) {
    //     const base = this.getItemFromStore(this.newItem.itemId).price;
    //     this.newItem.price = this.adjustedPrice(base, val);
    //     this.newItem.unitPrice = this.newItem.price;
    //     return;
    //   }
    //   if (this.newItem.outstockId) {
    //     const outstock = this.getItemFromStore(
    //       this.newItem.outstockId,
    //       "Fuori Magazzino"
    //     );
    //     const base =
    //       outstock.subCategory === "piastrelle"
    //         ? outstock.sqmPrice
    //         : outstock.price;
    //     this.newItem.unitPrice = Number(this.adjustedPrice(base, val));
    //     const qty = this.newItem.pieces || 0;
    //     this.newItem.price = (this.newItem.unitPrice * qty).toFixed(2);
    //   }
    // },

    "newItem.iva"(val) {
      if (this.newItem.itemId) {
        const base = this.getItemFromStore(this.newItem.itemId, "STOCK").price;
        this.newItem.price = this.adjustedPrice(base, val);
        this.newItem.unitPrice = this.newItem.price;
        return;
      }
      if (this.newItem.outstockId) {
        const outstock = this.getItemFromStore(
          this.newItem.outstockId,
          "Fuori Magazzino"
        );
        const base =
          outstock.subCategory === "piastrelle"
            ? outstock.sqmPrice
            : outstock.price;
        this.newItem.unitPrice = Number(this.adjustedPrice(base, val));
        const qty = this.newItem.pieces || 0;
        this.newItem.price = (this.newItem.unitPrice * qty).toFixed(2);
      }
    },

    // 📝 sync riga in tabella
    newItem: {
      handler(nv) {
        if (!nv.itemId && !nv.outstockId) return;
        const row =
          nv.category === "Fuori Magazzino"
            ? this.formData.items.find((x) => x.outstockId === nv.outstockId)
            : this.formData.items.find((x) => x.itemId === nv.itemId);
        if (!row) return;
        const qty =
          this.selectedItem.category === "piastrelle"
            ? nv.boxQuantity
            : nv.pieces;
        row.quantity = qty;
        row.boxQuantity = nv.boxQuantity;
        row.pieces = nv.pieces;
        row.price = nv.price;
        row.iva = nv.iva;
      },
      deep: true,
    },
  },
};
</script>

<style src="@/css/CreateQuotePage.css"></style>
